import dt, { useCallback as b, createContext as _t, useContext as ut, useReducer as St, useRef as re, useState as G, useEffect as X, useMemo as ae, forwardRef as Tt } from "react";
import vt from "camelize-ts";
import Pt from "snakecase-keys";
var Ze, Fe = { exports: {} }, Pe = {}, Je, xe, ze = {};
function lt() {
  return Je || (Je = 1, e = ze, process.env.NODE_ENV !== "production" && (function() {
    var t = dt, s = 60103, n = 60106;
    e.Fragment = 60107;
    var A = 60108, v = 60114, S = 60109, y = 60110, L = 60112, f = 60113, p = 60120, E = 60115, T = 60116, I = 60121, a = 60122, _ = 60117, u = 60129, P = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var m = Symbol.for;
      s = m("react.element"), n = m("react.portal"), e.Fragment = m("react.fragment"), A = m("react.strict_mode"), v = m("react.profiler"), S = m("react.provider"), y = m("react.context"), L = m("react.forward_ref"), f = m("react.suspense"), p = m("react.suspense_list"), E = m("react.memo"), T = m("react.lazy"), I = m("react.block"), a = m("react.server.block"), _ = m("react.fundamental"), m("react.scope"), m("react.opaque.id"), u = m("react.debug_trace_mode"), m("react.offscreen"), P = m("react.legacy_hidden");
    }
    var D = typeof Symbol == "function" && Symbol.iterator, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(R) {
      for (var V = arguments.length, q = new Array(V > 1 ? V - 1 : 0), z = 1; z < V; z++) q[z - 1] = arguments[z];
      (function(Z, j, K) {
        var x = i.ReactDebugCurrentFrame, Q = "";
        if (c) {
          var se = o(c.type), k = c._owner;
          Q += (function(F, te, ce) {
            var pe = "";
            if (te) {
              var He = te.fileName, ve = He.replace(d, "");
              if (/^index\./.test(ve)) {
                var Ee = He.match(d);
                if (Ee) {
                  var $e = Ee[1];
                  $e && (ve = $e.replace(d, "") + "/" + ve);
                }
              }
              pe = " (at " + ve + ":" + te.lineNumber + ")";
            } else ce && (pe = " (created by " + ce + ")");
            return `
    in ` + (F || "Unknown") + pe;
          })(se, c._source, k && o(k.type));
        }
        (Q += x.getStackAddendum()) !== "" && (j += "%s", K = K.concat([Q]));
        var M = K.map(function(F) {
          return "" + F;
        });
        M.unshift("Warning: " + j), Function.prototype.apply.call(console[Z], console, M);
      })("error", R, q);
    }
    var d = /^(.*)[\\\/]/, h = 1;
    function o(R) {
      if (R == null) return null;
      if (typeof R.tag == "number" && r("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof R == "function") return R.displayName || R.name || null;
      if (typeof R == "string") return R;
      switch (R) {
        case e.Fragment:
          return "Fragment";
        case n:
          return "Portal";
        case v:
          return "Profiler";
        case A:
          return "StrictMode";
        case f:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof R == "object") switch (R.$$typeof) {
        case y:
          return "Context.Consumer";
        case S:
          return "Context.Provider";
        case L:
          return z = R, Z = R.render, j = "ForwardRef", K = Z.displayName || Z.name || "", z.displayName || (K !== "" ? j + "(" + K + ")" : j);
        case E:
          return o(R.type);
        case I:
          return o(R.render);
        case T:
          var V = (q = R)._status === h ? q._result : null;
          if (V) return o(V);
      }
      var q, z, Z, j, K;
      return null;
    }
    var l = {};
    i.ReactDebugCurrentFrame;
    var c = null;
    function g(R) {
      c = R;
    }
    var U, C, $ = i.ReactCurrentOwner, Y = Object.prototype.hasOwnProperty, J = { key: !0, ref: !0, __self: !0, __source: !0 };
    function ue(R, V, q, z, Z) {
      var j, K = {}, x = null, Q = null;
      for (j in q !== void 0 && (x = "" + q), (function(M) {
        if (Y.call(M, "key")) {
          var F = Object.getOwnPropertyDescriptor(M, "key").get;
          if (F && F.isReactWarning) return !1;
        }
        return M.key !== void 0;
      })(V) && (x = "" + V.key), (function(M) {
        if (Y.call(M, "ref")) {
          var F = Object.getOwnPropertyDescriptor(M, "ref").get;
          if (F && F.isReactWarning) return !1;
        }
        return M.ref !== void 0;
      })(V) && (Q = V.ref, (function(M) {
        typeof M.ref == "string" && $.current;
      })(V)), V) Y.call(V, j) && !J.hasOwnProperty(j) && (K[j] = V[j]);
      if (R && R.defaultProps) {
        var se = R.defaultProps;
        for (j in se) K[j] === void 0 && (K[j] = se[j]);
      }
      if (x || Q) {
        var k = typeof R == "function" ? R.displayName || R.name || "Unknown" : R;
        x && (function(M, F) {
          var te = function() {
            U || (U = !0, r("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
          };
          te.isReactWarning = !0, Object.defineProperty(M, "key", { get: te, configurable: !0 });
        })(K, k), Q && (function(M, F) {
          var te = function() {
            C || (C = !0, r("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
          };
          te.isReactWarning = !0, Object.defineProperty(M, "ref", { get: te, configurable: !0 });
        })(K, k);
      }
      return (function(M, F, te, ce, pe, He, ve) {
        var Ee = { $$typeof: s, type: M, key: F, ref: te, props: ve, _owner: He, _store: {} };
        return Object.defineProperty(Ee._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(Ee, "_self", { configurable: !1, enumerable: !1, writable: !1, value: ce }), Object.defineProperty(Ee, "_source", { configurable: !1, enumerable: !1, writable: !1, value: pe }), Object.freeze && (Object.freeze(Ee.props), Object.freeze(Ee)), Ee;
      })(R, x, Q, Z, z, $.current, K);
    }
    var w, W = i.ReactCurrentOwner;
    function ie(R) {
      c = R;
    }
    function he(R) {
      return typeof R == "object" && R !== null && R.$$typeof === s;
    }
    function Te() {
      if (W.current) {
        var R = o(W.current.type);
        if (R) return `

Check the render method of \`` + R + "`.";
      }
      return "";
    }
    i.ReactDebugCurrentFrame, w = !1;
    var ge = {};
    function Oe(R, V) {
      if (R._store && !R._store.validated && R.key == null) {
        R._store.validated = !0;
        var q = (function(Z) {
          var j = Te();
          if (!j) {
            var K = typeof Z == "string" ? Z : Z.displayName || Z.name;
            K && (j = `

Check the top-level render call using <` + K + ">.");
          }
          return j;
        })(V);
        if (!ge[q]) {
          ge[q] = !0;
          var z = "";
          R && R._owner && R._owner !== W.current && (z = " It was passed a child from " + o(R._owner.type) + "."), ie(R), r('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', q, z), ie(null);
        }
      }
    }
    function me(R, V) {
      if (typeof R == "object") {
        if (Array.isArray(R)) for (var q = 0; q < R.length; q++) {
          var z = R[q];
          he(z) && Oe(z, V);
        }
        else if (he(R)) R._store && (R._store.validated = !0);
        else if (R) {
          var Z = (function(x) {
            if (x === null || typeof x != "object") return null;
            var Q = D && x[D] || x["@@iterator"];
            return typeof Q == "function" ? Q : null;
          })(R);
          if (typeof Z == "function" && Z !== R.entries) for (var j, K = Z.call(R); !(j = K.next()).done; ) he(j.value) && Oe(j.value, V);
        }
      }
    }
    function Le(R) {
      var V, q = R.type;
      if (q != null && typeof q != "string") {
        if (typeof q == "function") V = q.propTypes;
        else {
          if (typeof q != "object" || q.$$typeof !== L && q.$$typeof !== E) return;
          V = q.propTypes;
        }
        if (V) {
          var z = o(q);
          (function(Z, j, K, x, Q) {
            var se = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var k in Z) if (se(Z, k)) {
              var M = void 0;
              try {
                if (typeof Z[k] != "function") {
                  var F = Error((x || "React class") + ": " + K + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Z[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw F.name = "Invariant Violation", F;
                }
                M = Z[k](j, k, x, K, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (te) {
                M = te;
              }
              !M || M instanceof Error || (g(Q), r("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", x || "React class", K, k, typeof M), g(null)), M instanceof Error && !(M.message in l) && (l[M.message] = !0, g(Q), r("Failed %s type: %s", K, M.message), g(null));
            }
          })(V, R.props, "prop", z, R);
        } else q.PropTypes === void 0 || w || (w = !0, r("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", o(q) || "Unknown"));
        typeof q.getDefaultProps != "function" || q.getDefaultProps.isReactClassApproved || r("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Re(R, V, q, z, Z, j) {
      var K = (function(F) {
        return typeof F == "string" || typeof F == "function" || F === e.Fragment || F === v || F === u || F === A || F === f || F === p || F === P || typeof F == "object" && F !== null && (F.$$typeof === T || F.$$typeof === E || F.$$typeof === S || F.$$typeof === y || F.$$typeof === L || F.$$typeof === _ || F.$$typeof === I || F[0] === a);
      })(R);
      if (!K) {
        var x, Q = "";
        (R === void 0 || typeof R == "object" && R !== null && Object.keys(R).length === 0) && (Q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), Q += Te(), R === null ? x = "null" : Array.isArray(R) ? x = "array" : R !== void 0 && R.$$typeof === s ? (x = "<" + (o(R.type) || "Unknown") + " />", Q = " Did you accidentally export a JSX literal instead of a component?") : x = typeof R, r("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, Q);
      }
      var se = ue(R, V, q, Z, j);
      if (se == null) return se;
      if (K) {
        var k = V.children;
        if (k !== void 0) if (z) if (Array.isArray(k)) {
          for (var M = 0; M < k.length; M++) me(k[M], R);
          Object.freeze && Object.freeze(k);
        } else r("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
        else me(k, R);
      }
      return R === e.Fragment ? (function(F) {
        for (var te = Object.keys(F.props), ce = 0; ce < te.length; ce++) {
          var pe = te[ce];
          if (pe !== "children" && pe !== "key") {
            ie(F), r("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", pe), ie(null);
            break;
          }
        }
        F.ref !== null && (ie(F), r("Invalid attribute `ref` supplied to `React.Fragment`."), ie(null));
      })(se) : Le(se), se;
    }
    var Ce = function(R, V, q) {
      return Re(R, V, q, !1);
    }, De = function(R, V, q) {
      return Re(R, V, q, !0);
    };
    e.jsx = Ce, e.jsxs = De;
  })()), ze;
  var e;
}
var Me = (xe || (xe = 1, process.env.NODE_ENV === "production" ? Fe.exports = (function() {
  if (Ze) return Pe;
  Ze = 1;
  var e = dt, t = 60103;
  if (Pe.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var s = Symbol.for;
    t = s("react.element"), Pe.Fragment = s("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, A = Object.prototype.hasOwnProperty, v = { key: !0, ref: !0, __self: !0, __source: !0 };
  function S(y, L, f) {
    var p, E = {}, T = null, I = null;
    for (p in f !== void 0 && (T = "" + f), L.key !== void 0 && (T = "" + L.key), L.ref !== void 0 && (I = L.ref), L) A.call(L, p) && !v.hasOwnProperty(p) && (E[p] = L[p]);
    if (y && y.defaultProps) for (p in L = y.defaultProps) E[p] === void 0 && (E[p] = L[p]);
    return { $$typeof: t, type: y, key: T, ref: I, props: E, _owner: n.current };
  }
  return Pe.jsx = S, Pe.jsxs = S, Pe;
})() : Fe.exports = lt()), Fe.exports);
const _n = () => ({ ENV: "staging", HIVEMIND_ENV: "stg.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://stg.hivery.ai/api/v1/curate", CURATE_API_V2: "https://stg.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://stg.hivery.ai/api/v1/ie", PREDICTION_API: "https://stg.hivery.ai/api/v1/prediction", SSDI_API: "https://stg.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://stg.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://stg.hivery.ai/api/v1/strategies", AGENT_API: "https://stg.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "gSrXJ9P8FvZdua2q1gYqswVOJqQqRpdd", AUTH0_DOMAIN: "auth.stg.hivery.ai", AUTH0_AUDIENCE: "propel-api-staging", PUSHER_APP_KEY: "ed81ada4152f5becc720", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "ed81ada4152f5becc720", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://stg.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.stg.hivery.ai" }), yt = (e) => {
  switch (e) {
    case "text/csv":
      return "csv";
    case "image/jpeg":
      return "jpeg";
    case "application/json":
      return "json";
    case "text/markdown":
      return "md";
    case "application/vnd.oasis.opendocument.presentation":
      return "odp";
    case "application/vnd.oasis.opendocument.spreadsheet":
      return "ods";
    case "image/png":
      return "png";
    case "application/pdf":
      return "pdg";
    case "application/vnd.ms-powerpoint":
      return "ppt";
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "pptx";
    case "application/vnd.rar":
      return "rar";
    case "application/rtf":
      return "rtf";
    case "application/x-tar":
      return "tar";
    case "text/plain":
      return "txt";
    case "application/vnd.ms-excel":
      return "xls";
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "xlsx";
    case "application/zip":
    case "application/x-zip-compressed":
      return "zip";
    default:
      return void console.warn("unsupported mime type", e);
  }
}, Ge = (e, t) => {
  let s, n = e;
  try {
    let A = t.split(".");
    for (A.length === 0 && (A = [t]); A.length > 0; ) {
      if (s = A.shift(), !s) return;
      if (Array.isArray(n[s])) {
        n = [];
        const v = A.splice(-1).join(".");
        for (let S = 0, y = e[s].length; S < y; S++) n.push(Ge(e[s][S], v));
      } else n = n[s];
    }
    return n;
  } catch (A) {
    return void console.error("unexpected error occurred while trying to find value from pointer", e, t, A);
  }
}, un = (e, t, s) => {
  let n, A = -1;
  for (let v = 0, S = e?.length; v < S; v += 1) if (n = Ge(e[v], t), Array.isArray(n)) {
    if (n.indexOf(s) !== -1) {
      A = v;
      break;
    }
  } else if (n === s) {
    A = v;
    break;
  }
  return A;
}, mt = (e, t, s = !1) => {
  const n = [...e].sort((A, v) => {
    let S = Ge(A, t.toString()), y = Ge(v, t.toString());
    return typeof S == "string" && (S = S.toLocaleLowerCase()), typeof y == "string" && (y = y.toLocaleLowerCase()), S === y ? 0 : S < y ? -1 : 1;
  });
  return s ? n.reverse() : n;
};
var ke, We, Qe, oe = {}, ee = {};
function Se() {
  if (ke) return ee;
  ke = 1;
  var e = ee.ValidationError = function(a, _, u, P, m, D) {
    if (Array.isArray(P) ? (this.path = P, this.property = P.reduce(function(r, d) {
      return r + y(d);
    }, "instance")) : P !== void 0 && (this.property = P), a && (this.message = a), u) {
      var i = u.$id || u.id;
      this.schema = i || u;
    }
    _ !== void 0 && (this.instance = _), this.name = m, this.argument = D, this.stack = this.toString();
  };
  e.prototype.toString = function() {
    return this.property + " " + this.message;
  };
  var t = ee.ValidatorResult = function(a, _, u, P) {
    this.instance = a, this.schema = _, this.options = u, this.path = P.path, this.propertyPath = P.propertyPath, this.errors = [], this.throwError = u && u.throwError, this.throwFirst = u && u.throwFirst, this.throwAll = u && u.throwAll, this.disableFormat = u && u.disableFormat === !0;
  };
  function s(a, _) {
    return _ + ": " + a.toString() + `
`;
  }
  function n(a) {
    typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, n), this.instance = a.instance, this.schema = a.schema, this.options = a.options, this.errors = a.errors;
  }
  t.prototype.addError = function(a) {
    var _;
    if (typeof a == "string") _ = new e(a, this.instance, this.schema, this.path);
    else {
      if (!a) throw new Error("Missing error detail");
      if (!a.message) throw new Error("Missing error message");
      if (!a.name) throw new Error("Missing validator type");
      _ = new e(a.message, this.instance, this.schema, this.path, a.name, a.argument);
    }
    if (this.errors.push(_), this.throwFirst) throw new n(this);
    if (this.throwError) throw _;
    return _;
  }, t.prototype.importErrors = function(a) {
    typeof a == "string" || a && a.validatorType ? this.addError(a) : a && a.errors && (this.errors = this.errors.concat(a.errors));
  }, t.prototype.toString = function(a) {
    return this.errors.map(s).join("");
  }, Object.defineProperty(t.prototype, "valid", { get: function() {
    return !this.errors.length;
  } }), ee.ValidatorResultError = n, n.prototype = new Error(), n.prototype.constructor = n, n.prototype.name = "Validation Error";
  var A = ee.SchemaError = function a(_, u) {
    this.message = _, this.schema = u, Error.call(this, _), typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, a);
  };
  A.prototype = Object.create(Error.prototype, { constructor: { value: A, enumerable: !1 }, name: { value: "SchemaError", enumerable: !1 } });
  var v = ee.SchemaContext = function(a, _, u, P, m) {
    this.schema = a, this.options = _, Array.isArray(u) ? (this.path = u, this.propertyPath = u.reduce(function(D, i) {
      return D + y(i);
    }, "instance")) : this.propertyPath = u, this.base = P, this.schemas = m;
  };
  v.prototype.resolve = function(a) {
    return I(this.base, a);
  }, v.prototype.makeChild = function(a, _) {
    var u = _ === void 0 ? this.path : this.path.concat([_]), P = a.$id || a.id;
    let m = I(this.base, P || "");
    var D = new v(a, this.options, u, m, Object.create(this.schemas));
    return P && !D.schemas[m] && (D.schemas[m] = a), D;
  };
  var S = ee.FORMAT_REGEXPS = { "date-time": /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/, date: /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/, time: /^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/, duration: /P(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S)|\d+(D|M(\d+D)?|Y(\d+M(\d+D)?)?)(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S))?|\d+W)/i, email: /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/, "idn-email": /^("(?:[!#-\[\]-\u{10FFFF}]|\\[\t -\u{10FFFF}])*"|[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*)@([!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*|\[[!-Z\^-\u{10FFFF}]*\])$/u, "ip-address": /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, ipv6: /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/, uri: /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/, "uri-reference": /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/, iri: /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/, "iri-reference": /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~-\u{10FFFF}]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~-\u{10FFFF}])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/u, uuid: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i, "uri-template": /(%[0-9a-f]{2}|[!#$&(-;=?@\[\]_a-z~]|\{[!#&+,./;=?@|]?(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?(,(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?)*\})*/iu, "json-pointer": /^(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*$/iu, "relative-json-pointer": /^\d+(#|(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*)$/iu, hostname: /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/, "host-name": /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/, "utc-millisec": function(a) {
    return typeof a == "string" && parseFloat(a) === parseInt(a, 10) && !isNaN(a);
  }, regex: function(a) {
    var _ = !0;
    try {
      new RegExp(a);
    } catch {
      _ = !1;
    }
    return _;
  }, style: /[\r\n\t ]*[^\r\n\t ][^:]*:[\r\n\t ]*[^\r\n\t ;]*[\r\n\t ]*;?/, color: /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/, phone: /^\+(?:[0-9] ?){6,14}[0-9]$/, alpha: /^[a-zA-Z]+$/, alphanumeric: /^[a-zA-Z0-9]+$/ };
  S.regexp = S.regex, S.pattern = S.regex, S.ipv4 = S["ip-address"], ee.isFormat = function(a, _, u) {
    if (typeof a == "string" && S[_] !== void 0) {
      if (S[_] instanceof RegExp) return S[_].test(a);
      if (typeof S[_] == "function") return S[_](a);
    } else if (u && u.customFormats && typeof u.customFormats[_] == "function") return u.customFormats[_](a);
    return !0;
  };
  var y = ee.makeSuffix = function(a) {
    return (a = a.toString()).match(/[.\s\[\]]/) || a.match(/^[\d]/) ? a.match(/^\d+$/) ? "[" + a + "]" : "[" + JSON.stringify(a) + "]" : "." + a;
  };
  function L(a, _, u, P) {
    typeof u == "object" ? _[P] = E(a[P], u) : a.indexOf(u) === -1 && _.push(u);
  }
  function f(a, _, u) {
    _[u] = a[u];
  }
  function p(a, _, u, P) {
    typeof _[P] == "object" && _[P] && a[P] ? u[P] = E(a[P], _[P]) : u[P] = _[P];
  }
  function E(a, _) {
    var u = Array.isArray(_), P = u && [] || {};
    return u ? (a = a || [], P = P.concat(a), _.forEach(L.bind(null, a, P))) : (a && typeof a == "object" && Object.keys(a).forEach(f.bind(null, a, P)), Object.keys(_).forEach(p.bind(null, a, _, P))), P;
  }
  function T(a) {
    return "/" + encodeURIComponent(a).replace(/~/g, "%7E");
  }
  ee.deepCompareStrict = function a(_, u) {
    if (typeof _ != typeof u) return !1;
    if (Array.isArray(_)) return !!Array.isArray(u) && _.length === u.length && _.every(function(D, i) {
      return a(_[i], u[i]);
    });
    if (typeof _ == "object") {
      if (!_ || !u) return _ === u;
      var P = Object.keys(_), m = Object.keys(u);
      return P.length === m.length && P.every(function(D) {
        return a(_[D], u[D]);
      });
    }
    return _ === u;
  }, ee.deepMerge = E, ee.objectGetPath = function(a, _) {
    for (var u, P = _.split("/").slice(1); typeof (u = P.shift()) == "string"; ) {
      var m = decodeURIComponent(u.replace(/~0/, "~").replace(/~1/g, "/"));
      if (!(m in a)) return;
      a = a[m];
    }
    return a;
  }, ee.encodePath = function(a) {
    return a.map(T).join("");
  }, ee.getDecimalPlaces = function(a) {
    var _ = 0;
    if (isNaN(a)) return _;
    typeof a != "number" && (a = Number(a));
    var u = a.toString().split("e");
    if (u.length === 2) {
      if (u[1][0] !== "-") return _;
      _ = Number(u[1].slice(1));
    }
    var P = u[0].split(".");
    return P.length === 2 && (_ += P[1].length), _;
  }, ee.isSchema = function(a) {
    return typeof a == "object" && a || typeof a == "boolean";
  };
  var I = ee.resolveUrl = function(a, _) {
    const u = new URL(_, new URL(a, "resolve://"));
    if (u.protocol === "resolve:") {
      const { pathname: P, search: m, hash: D } = u;
      return P + m + D;
    }
    return u.toString();
  };
  return ee;
}
var Be, Xe, et, tt, Ve = {};
function Ye() {
  if (Be) return Ve;
  Be = 1;
  var e = Se();
  function t(s, n) {
    this.id = s, this.ref = n;
  }
  return Ve.SchemaScanResult = t, Ve.scan = function(s, n) {
    function A(f, p) {
      if (!p || typeof p != "object") return;
      if (p.$ref) {
        let a = e.resolveUrl(f, p.$ref);
        return void (L[a] = L[a] ? L[a] + 1 : 0);
      }
      var E = p.$id || p.id;
      let T = e.resolveUrl(f, E);
      var I = E ? T : f;
      if (I) {
        if (I.indexOf("#") < 0 && (I += "#"), y[I]) {
          if (!e.deepCompareStrict(y[I], p)) throw new Error("Schema <" + I + "> already exists with different definition");
          return y[I];
        }
        y[I] = p, I[I.length - 1] == "#" && (y[I.substring(0, I.length - 1)] = p);
      }
      v(I + "/items", Array.isArray(p.items) ? p.items : [p.items]), v(I + "/extends", Array.isArray(p.extends) ? p.extends : [p.extends]), A(I + "/additionalItems", p.additionalItems), S(I + "/properties", p.properties), A(I + "/additionalProperties", p.additionalProperties), S(I + "/definitions", p.definitions), S(I + "/patternProperties", p.patternProperties), S(I + "/dependencies", p.dependencies), v(I + "/disallow", p.disallow), v(I + "/allOf", p.allOf), v(I + "/anyOf", p.anyOf), v(I + "/oneOf", p.oneOf), A(I + "/not", p.not);
    }
    function v(f, p) {
      if (Array.isArray(p)) for (var E = 0; E < p.length; E++) A(f + "/" + E, p[E]);
    }
    function S(f, p) {
      if (p && typeof p == "object") for (var E in p) A(f + "/" + E, p[E]);
    }
    var y = {}, L = {};
    return A(s, n), new t(y, L);
  }, Ve;
}
function Rt() {
  if (et) return Xe;
  et = 1;
  var e = (function() {
    if (Qe) return We;
    Qe = 1;
    var p = Se(), E = p.ValidatorResult, T = p.SchemaError, I = { ignoreProperties: { id: !0, default: !0, description: !0, title: !0, additionalItems: !0, then: !0, else: !0, $schema: !0, $ref: !0, extends: !0 } }, a = I.validators = {};
    function _(i, r, d, h, o) {
      var l = r.throwError, c = r.throwAll;
      r.throwError = !1, r.throwAll = !1;
      var g = this.validateSchema(i, o, r, d);
      return r.throwError = l, r.throwAll = c, !g.valid && h instanceof Function && h(g), g.valid;
    }
    function u(i, r) {
      if (Object.hasOwnProperty.call(i, r)) return i[r];
      if (r in i) {
        for (; i = Object.getPrototypeOf(i); ) if (Object.propertyIsEnumerable.call(i, r)) return i[r];
      }
    }
    function P(i, r, d, h, o, l) {
      if (this.types.object(i) && (!r.properties || r.properties[o] === void 0)) if (r.additionalProperties === !1) l.addError({ name: "additionalProperties", argument: o, message: "is not allowed to have the additional property " + JSON.stringify(o) });
      else {
        var c = r.additionalProperties || {};
        typeof d.preValidateProperty == "function" && d.preValidateProperty(i, o, c, d, h);
        var g = this.validateSchema(i[o], c, d, h.makeChild(c, o));
        g.instance !== l.instance[o] && (l.instance[o] = g.instance), l.importErrors(g);
      }
    }
    a.type = function(i, r, d, h) {
      if (i === void 0) return null;
      var o = new E(i, r, d, h), l = Array.isArray(r.type) ? r.type : [r.type];
      if (!l.some(this.testType.bind(this, i, r, d, h))) {
        var c = l.map(function(g) {
          if (g) {
            var U = g.$id || g.id;
            return U ? "<" + U + ">" : g + "";
          }
        });
        o.addError({ name: "type", argument: c, message: "is not of a type(s) " + c });
      }
      return o;
    }, a.anyOf = function(i, r, d, h) {
      if (i === void 0) return null;
      var o = new E(i, r, d, h), l = new E(i, r, d, h);
      if (!Array.isArray(r.anyOf)) throw new T("anyOf must be an array");
      if (!r.anyOf.some(_.bind(this, i, d, h, function(g) {
        l.importErrors(g);
      }))) {
        var c = r.anyOf.map(function(g, U) {
          var C = g.$id || g.id;
          return C ? "<" + C + ">" : g.title && JSON.stringify(g.title) || g.$ref && "<" + g.$ref + ">" || "[subschema " + U + "]";
        });
        d.nestedErrors && o.importErrors(l), o.addError({ name: "anyOf", argument: c, message: "is not any of " + c.join(",") });
      }
      return o;
    }, a.allOf = function(i, r, d, h) {
      if (i === void 0) return null;
      if (!Array.isArray(r.allOf)) throw new T("allOf must be an array");
      var o = new E(i, r, d, h), l = this;
      return r.allOf.forEach(function(c, g) {
        var U = l.validateSchema(i, c, d, h);
        if (!U.valid) {
          var C = c.$id || c.id || c.title && JSON.stringify(c.title) || c.$ref && "<" + c.$ref + ">" || "[subschema " + g + "]";
          o.addError({ name: "allOf", argument: { id: C, length: U.errors.length, valid: U }, message: "does not match allOf schema " + C + " with " + U.errors.length + " error[s]:" }), o.importErrors(U);
        }
      }), o;
    }, a.oneOf = function(i, r, d, h) {
      if (i === void 0) return null;
      if (!Array.isArray(r.oneOf)) throw new T("oneOf must be an array");
      var o = new E(i, r, d, h), l = new E(i, r, d, h), c = r.oneOf.filter(_.bind(this, i, d, h, function(U) {
        l.importErrors(U);
      })).length, g = r.oneOf.map(function(U, C) {
        return U.$id || U.id || U.title && JSON.stringify(U.title) || U.$ref && "<" + U.$ref + ">" || "[subschema " + C + "]";
      });
      return c !== 1 && (d.nestedErrors && o.importErrors(l), o.addError({ name: "oneOf", argument: g, message: "is not exactly one from " + g.join(",") })), o;
    }, a.if = function(i, r, d, h) {
      if (i === void 0) return null;
      if (!p.isSchema(r.if)) throw new Error('Expected "if" keyword to be a schema');
      var o, l = _.call(this, i, d, h, null, r.if), c = new E(i, r, d, h);
      if (l) {
        if (r.then === void 0) return;
        if (!p.isSchema(r.then)) throw new Error('Expected "then" keyword to be a schema');
        o = this.validateSchema(i, r.then, d, h.makeChild(r.then)), c.importErrors(o);
      } else {
        if (r.else === void 0) return;
        if (!p.isSchema(r.else)) throw new Error('Expected "else" keyword to be a schema');
        o = this.validateSchema(i, r.else, d, h.makeChild(r.else)), c.importErrors(o);
      }
      return c;
    }, a.propertyNames = function(i, r, d, h) {
      if (this.types.object(i)) {
        var o = new E(i, r, d, h), l = r.propertyNames !== void 0 ? r.propertyNames : {};
        if (!p.isSchema(l)) throw new T('Expected "propertyNames" to be a schema (object or boolean)');
        for (var c in i) if (u(i, c) !== void 0) {
          var g = this.validateSchema(c, l, d, h.makeChild(l));
          o.importErrors(g);
        }
        return o;
      }
    }, a.properties = function(i, r, d, h) {
      if (this.types.object(i)) {
        var o = new E(i, r, d, h), l = r.properties || {};
        for (var c in l) {
          var g = l[c];
          if (g !== void 0) {
            if (g === null) throw new T('Unexpected null, expected schema in "properties"');
            typeof d.preValidateProperty == "function" && d.preValidateProperty(i, c, g, d, h);
            var U = u(i, c), C = this.validateSchema(U, g, d, h.makeChild(g, c));
            C.instance !== o.instance[c] && (o.instance[c] = C.instance), o.importErrors(C);
          }
        }
        return o;
      }
    }, a.patternProperties = function(i, r, d, h) {
      if (this.types.object(i)) {
        var o = new E(i, r, d, h), l = r.patternProperties || {};
        for (var c in i) {
          var g = !0;
          for (var U in l) {
            var C = l[U];
            if (C !== void 0) {
              if (C === null) throw new T('Unexpected null, expected schema in "patternProperties"');
              try {
                var $ = new RegExp(U, "u");
              } catch {
                $ = new RegExp(U);
              }
              if ($.test(c)) {
                g = !1, typeof d.preValidateProperty == "function" && d.preValidateProperty(i, c, C, d, h);
                var Y = this.validateSchema(i[c], C, d, h.makeChild(C, c));
                Y.instance !== o.instance[c] && (o.instance[c] = Y.instance), o.importErrors(Y);
              }
            }
          }
          g && P.call(this, i, r, d, h, c, o);
        }
        return o;
      }
    }, a.additionalProperties = function(i, r, d, h) {
      if (this.types.object(i)) {
        if (r.patternProperties) return null;
        var o = new E(i, r, d, h);
        for (var l in i) P.call(this, i, r, d, h, l, o);
        return o;
      }
    }, a.minProperties = function(i, r, d, h) {
      if (this.types.object(i)) {
        var o = new E(i, r, d, h);
        return Object.keys(i).length >= r.minProperties || o.addError({ name: "minProperties", argument: r.minProperties, message: "does not meet minimum property length of " + r.minProperties }), o;
      }
    }, a.maxProperties = function(i, r, d, h) {
      if (this.types.object(i)) {
        var o = new E(i, r, d, h);
        return Object.keys(i).length <= r.maxProperties || o.addError({ name: "maxProperties", argument: r.maxProperties, message: "does not meet maximum property length of " + r.maxProperties }), o;
      }
    }, a.items = function(i, r, d, h) {
      var o = this;
      if (this.types.array(i) && r.items !== void 0) {
        var l = new E(i, r, d, h);
        return i.every(function(c, g) {
          if (Array.isArray(r.items)) var U = r.items[g] === void 0 ? r.additionalItems : r.items[g];
          else U = r.items;
          if (U === void 0) return !0;
          if (U === !1) return l.addError({ name: "items", message: "additionalItems not permitted" }), !1;
          var C = o.validateSchema(c, U, d, h.makeChild(U, g));
          return C.instance !== l.instance[g] && (l.instance[g] = C.instance), l.importErrors(C), !0;
        }), l;
      }
    }, a.contains = function(i, r, d, h) {
      var o = this;
      if (this.types.array(i) && r.contains !== void 0) {
        if (!p.isSchema(r.contains)) throw new Error('Expected "contains" keyword to be a schema');
        var l = new E(i, r, d, h);
        return i.some(function(c, g) {
          return o.validateSchema(c, r.contains, d, h.makeChild(r.contains, g)).errors.length === 0;
        }) === !1 && l.addError({ name: "contains", argument: r.contains, message: "must contain an item matching given schema" }), l;
      }
    }, a.minimum = function(i, r, d, h) {
      if (this.types.number(i)) {
        var o = new E(i, r, d, h);
        return r.exclusiveMinimum && r.exclusiveMinimum === !0 ? i > r.minimum || o.addError({ name: "minimum", argument: r.minimum, message: "must be greater than " + r.minimum }) : i >= r.minimum || o.addError({ name: "minimum", argument: r.minimum, message: "must be greater than or equal to " + r.minimum }), o;
      }
    }, a.maximum = function(i, r, d, h) {
      if (this.types.number(i)) {
        var o = new E(i, r, d, h);
        return r.exclusiveMaximum && r.exclusiveMaximum === !0 ? i < r.maximum || o.addError({ name: "maximum", argument: r.maximum, message: "must be less than " + r.maximum }) : i <= r.maximum || o.addError({ name: "maximum", argument: r.maximum, message: "must be less than or equal to " + r.maximum }), o;
      }
    }, a.exclusiveMinimum = function(i, r, d, h) {
      if (typeof r.exclusiveMinimum != "boolean" && this.types.number(i)) {
        var o = new E(i, r, d, h);
        return i > r.exclusiveMinimum || o.addError({ name: "exclusiveMinimum", argument: r.exclusiveMinimum, message: "must be strictly greater than " + r.exclusiveMinimum }), o;
      }
    }, a.exclusiveMaximum = function(i, r, d, h) {
      if (typeof r.exclusiveMaximum != "boolean" && this.types.number(i)) {
        var o = new E(i, r, d, h);
        return i < r.exclusiveMaximum || o.addError({ name: "exclusiveMaximum", argument: r.exclusiveMaximum, message: "must be strictly less than " + r.exclusiveMaximum }), o;
      }
    };
    var m = function(i, r, d, h, o, l) {
      if (this.types.number(i)) {
        var c = r[o];
        if (c == 0) throw new T(o + " cannot be zero");
        var g = new E(i, r, d, h), U = p.getDecimalPlaces(i), C = p.getDecimalPlaces(c), $ = Math.max(U, C), Y = Math.pow(10, $);
        return Math.round(i * Y) % Math.round(c * Y) !== 0 && g.addError({ name: o, argument: c, message: l + JSON.stringify(c) }), g;
      }
    };
    function D(i, r, d) {
      var h, o = d.length;
      for (h = r + 1; h < o; h++) if (p.deepCompareStrict(i, d[h])) return !1;
      return !0;
    }
    return a.multipleOf = function(i, r, d, h) {
      return m.call(this, i, r, d, h, "multipleOf", "is not a multiple of (divisible by) ");
    }, a.divisibleBy = function(i, r, d, h) {
      return m.call(this, i, r, d, h, "divisibleBy", "is not divisible by (multiple of) ");
    }, a.required = function(i, r, d, h) {
      var o = new E(i, r, d, h);
      return i === void 0 && r.required === !0 ? o.addError({ name: "required", message: "is required" }) : this.types.object(i) && Array.isArray(r.required) && r.required.forEach(function(l) {
        u(i, l) === void 0 && o.addError({ name: "required", argument: l, message: "requires property " + JSON.stringify(l) });
      }), o;
    }, a.pattern = function(i, r, d, h) {
      if (this.types.string(i)) {
        var o = new E(i, r, d, h), l = r.pattern;
        try {
          var c = new RegExp(l, "u");
        } catch {
          c = new RegExp(l);
        }
        return i.match(c) || o.addError({ name: "pattern", argument: r.pattern, message: "does not match pattern " + JSON.stringify(r.pattern.toString()) }), o;
      }
    }, a.format = function(i, r, d, h) {
      if (i !== void 0) {
        var o = new E(i, r, d, h);
        return o.disableFormat || p.isFormat(i, r.format, this) || o.addError({ name: "format", argument: r.format, message: "does not conform to the " + JSON.stringify(r.format) + " format" }), o;
      }
    }, a.minLength = function(i, r, d, h) {
      if (this.types.string(i)) {
        var o = new E(i, r, d, h), l = i.match(/[\uDC00-\uDFFF]/g);
        return i.length - (l ? l.length : 0) >= r.minLength || o.addError({ name: "minLength", argument: r.minLength, message: "does not meet minimum length of " + r.minLength }), o;
      }
    }, a.maxLength = function(i, r, d, h) {
      if (this.types.string(i)) {
        var o = new E(i, r, d, h), l = i.match(/[\uDC00-\uDFFF]/g);
        return i.length - (l ? l.length : 0) <= r.maxLength || o.addError({ name: "maxLength", argument: r.maxLength, message: "does not meet maximum length of " + r.maxLength }), o;
      }
    }, a.minItems = function(i, r, d, h) {
      if (this.types.array(i)) {
        var o = new E(i, r, d, h);
        return i.length >= r.minItems || o.addError({ name: "minItems", argument: r.minItems, message: "does not meet minimum length of " + r.minItems }), o;
      }
    }, a.maxItems = function(i, r, d, h) {
      if (this.types.array(i)) {
        var o = new E(i, r, d, h);
        return i.length <= r.maxItems || o.addError({ name: "maxItems", argument: r.maxItems, message: "does not meet maximum length of " + r.maxItems }), o;
      }
    }, a.uniqueItems = function(i, r, d, h) {
      if (r.uniqueItems === !0 && this.types.array(i)) {
        var o = new E(i, r, d, h);
        return i.every(D) || o.addError({ name: "uniqueItems", message: "contains duplicate item" }), o;
      }
    }, a.dependencies = function(i, r, d, h) {
      if (this.types.object(i)) {
        var o = new E(i, r, d, h);
        for (var l in r.dependencies) if (i[l] !== void 0) {
          var c = r.dependencies[l], g = h.makeChild(c, l);
          if (typeof c == "string" && (c = [c]), Array.isArray(c)) c.forEach(function(C) {
            i[C] === void 0 && o.addError({ name: "dependencies", argument: g.propertyPath, message: "property " + C + " not found, required by " + g.propertyPath });
          });
          else {
            var U = this.validateSchema(i, c, d, g);
            o.instance !== U.instance && (o.instance = U.instance), U && U.errors.length && (o.addError({ name: "dependencies", argument: g.propertyPath, message: "does not meet dependency required by " + g.propertyPath }), o.importErrors(U));
          }
        }
        return o;
      }
    }, a.enum = function(i, r, d, h) {
      if (i === void 0) return null;
      if (!Array.isArray(r.enum)) throw new T("enum expects an array", r);
      var o = new E(i, r, d, h);
      return r.enum.some(p.deepCompareStrict.bind(null, i)) || o.addError({ name: "enum", argument: r.enum, message: "is not one of enum values: " + r.enum.map(String).join(",") }), o;
    }, a.const = function(i, r, d, h) {
      if (i === void 0) return null;
      var o = new E(i, r, d, h);
      return p.deepCompareStrict(r.const, i) || o.addError({ name: "const", argument: r.const, message: "does not exactly match expected constant: " + r.const }), o;
    }, a.not = a.disallow = function(i, r, d, h) {
      var o = this;
      if (i === void 0) return null;
      var l = new E(i, r, d, h), c = r.not || r.disallow;
      return c ? (Array.isArray(c) || (c = [c]), c.forEach(function(g) {
        if (o.testType(i, r, d, h, g)) {
          var U = g && (g.$id || g.id) || g;
          l.addError({ name: "not", argument: U, message: "is of prohibited type " + U });
        }
      }), l) : null;
    }, We = I;
  })(), t = Se(), s = Ye().scan, n = t.ValidatorResult, A = t.ValidatorResultError, v = t.SchemaError, S = t.SchemaContext, y = function p() {
    this.customFormats = Object.create(p.prototype.customFormats), this.schemas = {}, this.unresolvedRefs = [], this.types = Object.create(f), this.attributes = Object.create(e.validators);
  };
  function L(p) {
    var E = typeof p == "string" ? p : p.$ref;
    return typeof E == "string" && E;
  }
  y.prototype.customFormats = {}, y.prototype.schemas = null, y.prototype.types = null, y.prototype.attributes = null, y.prototype.unresolvedRefs = null, y.prototype.addSchema = function(p, E) {
    var T = this;
    if (!p) return null;
    var I = s(E || "/", p), a = E || p.$id || p.id;
    for (var _ in I.id) this.schemas[_] = I.id[_];
    for (var _ in I.ref) this.unresolvedRefs.push(_);
    return this.unresolvedRefs = this.unresolvedRefs.filter(function(u) {
      return T.schemas[u] === void 0;
    }), this.schemas[a];
  }, y.prototype.addSubSchemaArray = function(p, E) {
    if (Array.isArray(E)) for (var T = 0; T < E.length; T++) this.addSubSchema(p, E[T]);
  }, y.prototype.addSubSchemaObject = function(p, E) {
    if (E && typeof E == "object") for (var T in E) this.addSubSchema(p, E[T]);
  }, y.prototype.setSchemas = function(p) {
    this.schemas = p;
  }, y.prototype.getSchema = function(p) {
    return this.schemas[p];
  }, y.prototype.validate = function(p, E, T, I) {
    if (typeof E != "boolean" && typeof E != "object" || E === null) throw new v("Expected `schema` to be an object or boolean");
    T || (T = {});
    var a = E.$id || E.id;
    let _ = t.resolveUrl(T.base, a || "");
    if (!I) {
      (I = new S(E, T, [], _, Object.create(this.schemas))).schemas[_] || (I.schemas[_] = E);
      var u = s(_, E);
      for (var P in u.id) {
        var m = u.id[P];
        I.schemas[P] = m;
      }
    }
    var D;
    if (T.required && p === void 0) return (D = new n(p, E, T, I)).addError("is required, but is undefined"), D;
    if (!(D = this.validateSchema(p, E, T, I))) throw new Error("Result undefined");
    if (T.throwAll && D.errors.length) throw new A(D);
    return D;
  }, y.prototype.validateSchema = function(p, E, T, I) {
    var a = new n(p, E, T, I);
    if (typeof E == "boolean") E === !0 ? E = {} : E === !1 && (E = { type: [] });
    else if (!E) throw new Error("schema is undefined");
    if (E.extends) if (Array.isArray(E.extends)) {
      var _ = { schema: E, ctx: I };
      E.extends.forEach(this.schemaTraverser.bind(this, _)), E = _.schema, _.schema = null, _.ctx = null, _ = null;
    } else E = t.deepMerge(E, this.superResolve(E.extends, I));
    var u = L(E);
    if (u) {
      var P = this.resolve(E, u, I), m = new S(P.subschema, T, I.path, P.switchSchema, I.schemas);
      return this.validateSchema(p, P.subschema, T, m);
    }
    var D = T && T.skipAttributes || [];
    for (var i in E) if (!e.ignoreProperties[i] && D.indexOf(i) < 0) {
      var r = null, d = this.attributes[i];
      if (d) r = d.call(this, p, E, T, I);
      else if (T.allowUnknownAttributes === !1) throw new v("Unsupported attribute: " + i, E);
      r && a.importErrors(r);
    }
    if (typeof T.rewrite == "function") {
      var h = T.rewrite.call(this, p, E, T, I);
      a.instance = h;
    }
    return a;
  }, y.prototype.schemaTraverser = function(p, E) {
    p.schema = t.deepMerge(p.schema, this.superResolve(E, p.ctx));
  }, y.prototype.superResolve = function(p, E) {
    var T = L(p);
    return T ? this.resolve(p, T, E).subschema : p;
  }, y.prototype.resolve = function(p, E, T) {
    if (E = T.resolve(E), T.schemas[E]) return { subschema: T.schemas[E], switchSchema: E };
    let I = new URL(E, "thismessage::/").hash;
    var a = I && I.length && E.substr(0, E.length - I.length);
    if (!a || !T.schemas[a]) throw new v("no such schema <" + E + ">", p);
    var _ = t.objectGetPath(T.schemas[a], I.substr(1));
    if (_ === void 0) throw new v("no such schema " + I + " located in <" + a + ">", p);
    return { subschema: _, switchSchema: E };
  }, y.prototype.testType = function(p, E, T, I, a) {
    if (a !== void 0) {
      if (a === null) throw new v('Unexpected null in "type" keyword');
      if (typeof this.types[a] == "function") return this.types[a].call(this, p);
      if (a && typeof a == "object") {
        var _ = this.validateSchema(p, a, T, I);
        return _ === void 0 || !(_ && _.errors.length);
      }
      return !0;
    }
  };
  var f = y.prototype.types = {};
  return f.string = function(p) {
    return typeof p == "string";
  }, f.number = function(p) {
    return typeof p == "number" && isFinite(p);
  }, f.integer = function(p) {
    return typeof p == "number" && p % 1 == 0;
  }, f.boolean = function(p) {
    return typeof p == "boolean";
  }, f.array = function(p) {
    return Array.isArray(p);
  }, f.null = function(p) {
    return p === null;
  }, f.date = function(p) {
    return p instanceof Date;
  }, f.any = function(p) {
    return !0;
  }, f.object = function(p) {
    return p && typeof p == "object" && !Array.isArray(p) && !(p instanceof Date);
  }, Xe = y;
}
var Ke = (function() {
  if (tt) return oe;
  tt = 1;
  var e = oe.Validator = Rt();
  return oe.ValidatorResult = Se().ValidatorResult, oe.ValidatorResultError = Se().ValidatorResultError, oe.ValidationError = Se().ValidationError, oe.SchemaError = Se().SchemaError, oe.SchemaScanResult = Ye().SchemaScanResult, oe.scan = Ye().scan, oe.validate = function(t, s, n) {
    return new e().validate(t, s, n);
  }, oe;
})();
const B = (e, t) => {
  if (!t) return console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: body missing` }), !1;
  try {
    if (!e.properties) return console.error({ name: "ValidationError", message: "Schema does not have any properties to validate", schema: e }), !1;
    const n = Object.entries(e.properties), A = Object.keys(t);
    if (n.length < A.length) return console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: body has more properties (${A.length}) than schema (${n.length})` }), !1;
  } catch (n) {
    return console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: unexpected error`, data: n }), !1;
  }
  const s = Ke.validate(t, e, { required: !0 });
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: invalid body`, data: s.errors }), s.valid;
}, H = (e, t) => {
  const s = Ke.validate(t, e);
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: invalid params`, data: s.errors }), s.valid;
}, ne = (e, t) => {
  const s = Ke.validate(t, e);
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: invalid query`, data: s.errors }), s.valid;
}, qe = (e) => {
  if (!e) return "";
  const t = {};
  for (const [s, n] of Object.entries(e)) n && (t[s] = n.toString());
  return Object.keys(t).length ? `?${new URLSearchParams(t).toString()}` : "";
};
var ft = ((e) => (e.IndexSizeError = "IndexSizeError", e.HierarchyRequestError = "HierarchyRequestError", e.WrongDocumentError = "WrongDocumentError", e.InvalidCharacterError = "InvalidCharacterError", e.NoModificationAllowedError = "NoModificationAllowedError", e.NotFoundError = "NotFoundError", e.NotSupportedError = "NotSupportedError", e.InvalidStateError = "InvalidStateError", e.InUseAttributeError = "InUseAttributeError", e.SyntaxError = "SyntaxError", e.InvalidModificationError = "InvalidModificationError", e.NamespaceError = "NamespaceError", e.InvalidAccessError = "InvalidAccessError", e.SecurityError = "SecurityError", e.NetworkError = "NetworkError", e.AbortError = "AbortError", e.URLMismatchError = "URLMismatchError", e.QuotaExceededError = "QuotaExceededError", e.TimeoutError = "TimeoutError", e.InvalidNodeTypeError = "InvalidNodeTypeError", e.DataCloneError = "DataCloneError", e.EncodingError = "EncodingError", e.NotReadableError = "NotReadableError", e.UnknownError = "UnknownError", e.ConstraintError = "ConstraintError", e.DataError = "DataError", e.TransactionInactiveError = "TransactionInactiveError", e.ReadOnlyError = "ReadOnlyError", e.VersionError = "VersionError", e.OperationError = "OperationError", e.NotAllowedError = "NotAllowedError", e))(ft || {});
const Ut = (e, t) => e instanceof DOMException && (e.name === "AbortError" ? (console.warn(t && t.reason ? t.reason : e), !0) : (console.debug("unhandled DOM exception"), console.error(e), !1)), Nt = (e) => b((t) => {
  e({ type: "SET_USER_FEATURES", data: t });
}, [e]), rt = { type: "SET_USER_FEATURES", action: (e, t) => ({ ...e, features: t }) }, Ot = (e) => b((t) => {
  e({ type: "SET_USER_TENANCY", data: t });
}, [e]), at = { type: "SET_USER_TENANCY", action: (e, t) => ({ ...e, tenant: t }) }, Lt = (e) => b((t) => {
  e({ type: "SET_USER_TENANCY_SLUG", data: t });
}, [e]), it = { type: "SET_USER_TENANCY_SLUG", action: (e, t) => ({ ...e, slug: t }) }, Ct = (e) => b((t) => {
  e({ type: "SET_USER_TOKEN", data: t });
}, [e]), st = { type: "SET_USER_TOKEN", action: (e, t) => ({ ...e, token: t }) }, Dt = (e) => b((t) => {
  e({ type: "SET_USER", data: t });
}, [e]), nt = { type: "SET_USER", action: (e, t) => ({ ...e, ...t }) }, Ht = (e, t) => {
  switch (t.type) {
    case nt.type:
      return nt.action(e, t.data);
    case rt.type:
      return rt.action(e, t.data);
    case at.type:
      return at.action(e, t.data);
    case it.type:
      return it.action(e, t.data);
    case st.type:
      return st.action(e, t.data);
  }
}, ht = { tenant: "", slug: "", token: "", isLoggedIn: !1 }, fe = () => {
  console.warn("unable to use state USER: state not setup");
}, Vt = { ...ht, setUser: fe, setUserTenant: fe, setUserTenantSlug: fe, setUserToken: fe, setUserFeatures: fe }, ct = _t(Vt), bt = () => ut(ct), hn = ({ children: e }) => {
  const [t, s] = St(Ht, { ...ht }), n = { ...t, setUser: Dt(s), setUserTenant: Ot(s), setUserTenantSlug: Lt(s), setUserToken: Ct(s), setUserFeatures: Nt(s) };
  return Me.jsx(ct.Provider, { value: n, children: e });
}, Ne = () => {
  const { token: e, slug: t } = bt();
  return b(({ url: s, method: n, headers: A, body: v, signal: S, camel: y = !0, authRequired: L, tenantRequired: f }) => {
    if (L && (!e || f && !t)) {
      const E = { type: "process-error", status_code: -1, error_code: "ServiceNotReady", message: "unable to fetch data: token or tenant is not set" };
      return Promise.reject({ isError: !0, data: E });
    }
    const p = A ? { ...A } : {};
    return p.Accept || (p.Accept = "application/json"), p["Content-Type"] || (p["Content-Type"] = "application/json"), p["Content-Type"] === "multipart/form-data" && delete p["Content-Type"], p.Authorization = `Bearer ${e}`, p["x-curate-tenant-slug"] = t, p["x-request-id"] = window.crypto.randomUUID(), new Promise((E, T) => {
      const I = (a, _) => {
        const u = Ut(a, S), P = !_ || Mt(_?.status, a);
        if (u || P || console.error(a), a.status_code) {
          const m = { isError: !0, data: { ...a, type: "http-error" } };
          T(m);
        } else
          T({ isError: !0, data: a });
      };
      fetch(s, { method: n, headers: p, body: v === void 0 ? null : p["Content-Type"] === "application/json" ? JSON.stringify(Pt(v)) : v }).then((a) => {
        const _ = /* @__PURE__ */ ((r) => (d) => {
          I(d, r);
        })(a);
        if (!a.ok) return void _({ status: a.status, statusText: a.statusText });
        const u = a.headers.get("Content-Type");
        if (!u)
          return void T({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "UnknownContentType", message: "unable to export planogram: missing content type from response", response: a } });
        const P = u.split(";")[0], m = (r) => {
          E({ isError: !1, data: y ? vt(r) : r });
        }, D = (r) => {
          E({ isError: !1, data: r });
        }, i = (r) => {
          E({ isError: !1, data: r });
        };
        switch (P) {
          case "text/csv":
          case "text/plain":
            a.text().then(D, T).catch(_);
            break;
          case "application/json":
            a.json().then(m, T).catch(_);
            break;
          case "application/zip":
            a.blob().then(i, T).catch(_);
            break;
          default:
            T({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "UnknownMediaType", message: `unable to export document assortment: media type ${P} is not supported`, response: a } });
            break;
        }
      }, I).catch(I);
    });
  }, [e, t]);
};
var N = ((e) => (e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.DELETE = "DELETE", e))(N || {});
const cn = ({ getEndpoint: e, preflightValidation: t, chunkSize: s = 6, onUpdate: n }) => {
  const A = Ne(), v = re(!1), [S, y] = G(!1), [L, f] = G(!1), [p, E] = G(), [T, I] = G(), a = re([]), _ = re([]), [u, P] = G([]), [m, D] = G(0), i = b((d) => {
    if (!d.length) return void console.warn("batch has nothing to process", u, d);
    const h = [];
    let o = !1, l = "", c = "";
    _.current = [];
    for (let g = 0, U = d.length; g < U; g++) {
      if (o = !t || t(d[g]), !o) {
        console.warn("batch request error: failed to pass preflightValidation", d[g]);
        break;
      }
      if (l = e(d[g]), !l) {
        o = !1, console.warn("batch request error: failed to create url", d[g]);
        break;
      }
      const C = new AbortController();
      _.current.push(C), c = qe(d[g].query || {}), h.push({ ...d[g], url: c ? `${l}${c}` : l, method: N.GET, signal: C.signal });
    }
    h.length ? o ? (a.current = h.map((g) => A(g)), y(!0)) : console.warn("batch has invalid request") : console.debug("batch process does not have requests to send");
  }, [u, A, e, t]), r = b((d) => {
    d.length ? (f(!1), E(void 0), P(d), D(0)) : console.warn("batch request requires an list of params and/or queries");
  }, []);
  return X(() => {
    if (!u || !u.length) return;
    const d = m, h = m + s, o = u.slice(d, h);
    o.length ? i(o) : console.warn("next batch empty", d, h, u);
  }, [u, m, s, i]), X(() => {
    S && a.current.length && Promise.allSettled(a.current).then((d) => {
      const h = [], o = [];
      d.forEach((c) => {
        c.status !== "rejected" ? c.value.isError ? h.push(c.value) : o.push(c.value.data) : h.push(c.reason);
      }), h.length && (I(h), console.warn(h)), E((c) => c ? (n && n(o.slice(), c.slice()), c.concat(o)) : (n && n(o.slice(), []), o));
      const l = m + s;
      l < u.length ? D(l) : (f(!0), y(!1));
    }).catch((d) => {
      I([d]), f(!0), y(!1);
    });
  }, [u.length, m, s, S, n]), X(() => (v.current = !0, () => {
    v.current = !1, _.current && _.current.length && _.current.forEach((d) => {
      d.abort();
    });
  }), []), [S, L, p, r, T];
}, Gt = ({ maxConcurrency: e = 8, getEndpoint: t, preflightValidation: s, method: n, headers: A, onFinish: v, onError: S, onResponse: y, onEmptyQueue: L }) => {
  const f = Ne(), p = re(!1), E = re(/* @__PURE__ */ new Map()), T = re(null), [I, a] = G(!1), [_, u] = G(0), P = b((r) => {
    S && S(r);
  }, [S]), m = b(() => {
    u((r) => r + 1);
  }, []), D = b(() => {
    if (E.current.size < e && T.current !== null) {
      const o = performance.now().toFixed(0).toString();
      E.current.set(o, { args: T.current.args }), T.current.resolve(!0), T.current = null;
    }
    if (!E.current.size && !T.current) return m(), void a(!1);
    const r = Array.from(E.current.keys());
    let d = 0;
    const h = [];
    for (a(!0); d < r.length && E.current.size > 0; ) {
      const o = r[d], l = E.current.get(o);
      if (d++, !l) {
        E.current.delete(o);
        continue;
      }
      if (l.abortController) continue;
      if (!(!s || s(l.args))) {
        P({ name: "InvalidPreFlightValidation", details: l.args }), E.current.delete(o);
        continue;
      }
      const c = t(l.args);
      if (!c) {
        P({ name: "InvalidUrl", details: l.args }), E.current.delete(o);
        continue;
      }
      const g = new AbortController(), U = f({ url: c, method: n, headers: A, signal: g.signal, body: l.args.body });
      h.push(U), E.current.set(o, { args: l.args, abortController: g }), U.finally(() => {
        v && v({ params: l.args.params }), E.current.delete(o);
      });
    }
    Promise.race(h).then((o) => {
      y && y(o), D();
    }, P);
  }, [e, P, m, s, t, f, n, A, v, y]), i = b((r) => new Promise((d) => {
    if (E.current.size < e) {
      const h = performance.now().toFixed(0).toString();
      return E.current.set(h, { args: r }), D(), void d(!0);
    }
    T.current = { resolve: d, args: r };
  }), [e, D]);
  return X(() => {
    _ && L && (L(_), u(0));
  }, [L, _]), X(() => (p.current = !0, () => {
    p.current = !1, E.current && E.current.size && (E.current.forEach((r) => {
      r.abortController && r.abortController.abort();
    }), E.current = /* @__PURE__ */ new Map());
  }), []), [I, i];
}, qt = (e, t, s, n) => {
  const A = e - t, v = Math.ceil(A / s);
  return v ? v - n > -1 ? n : v : -1;
}, Ft = ({ getEndpoint: e, pageLimit: t, chunkLimit: s, requestDelay: n, onUpdate: A, onComplete: v, onFailure: S }) => {
  const y = Ne(), L = re(!1), f = re(), [p, E] = G(), [T, I] = G(!1), [a, _] = G(), [u, P] = G([]), m = b(() => {
    f.current && f.current.abort(), p && clearTimeout(p);
  }, [p]), D = b((i, r, d = !0) => {
    d && m();
    const h = (({ response: c, direction: g = "next" }) => {
      if (!Object.hasOwn(c, g) || c[g] === void 0 || c[g] === null) return console.warn(`unable to get offset value: response has no ${g} url`, c), -1;
      const U = c[g];
      if (U == null || typeof U != "string") return console.warn(`unable to get offset value: response has no ${g} url`, c), -1;
      const C = new URL(U).searchParams.get("offset");
      if (!C) return console.warn("unable to get offset value: offset param missing from response next url", c), -1;
      const $ = parseInt(C);
      return isNaN($) ? (console.warn("unable to get offset value: offset param is not a number", c, C), -1) : $;
    })({ response: i });
    if (I(!0), h === -1) {
      if (i.count !== i.results.length) return void console.warn("unable to send request chunks: no offset", i, h);
      const c = [...u, ...i.results];
      return P(c), A && A(i.results, c), v && v(), void I(!1);
    }
    const o = qt(i.count, h, t, s);
    if (o === -1) return console.warn("unable to get next chunk: no chunks left", i, o), void I(!1);
    const l = setTimeout(() => {
      const c = [];
      f.current = new AbortController(), _(void 0);
      for (let g = 0; g < o; g++) {
        const U = e(r);
        if (!U) {
          const Y = { isError: !0, data: { type: "process-error", status_code: -1, error_code: "MalformedURL", message: "unable to DRAIN: url is missing" } };
          console.warn(Y, r), _(Y), I(!1);
          break;
        }
        let C = "";
        Object.hasOwn(r, "query") && (C = qe({ ...r.query, offset: g * t + h, limit: t }));
        const $ = { ...r, url: `${U}${C}`, method: N.GET, signal: f.current.signal };
        c.push(y($));
      }
      Promise.allSettled(c).then((g) => {
        if (!L.current) return;
        const U = [], C = [];
        let $;
        if (g.forEach((J) => {
          J.status === "rejected" ? U.push(J.reason) : J.status === "fulfilled" && (J.value.isError ? U.push(J.value) : (C.push(...J.value.data.results), $ = J.value.data));
        }), !$) {
          const J = { isError: !0, data: { type: "process-error", status_code: -1, error_code: "NoLastChunk", message: "unable to get next chunk: chunks malformed" } };
          return U.push(J), _(U), void (S && S(U));
        }
        U.length && S && S(U);
        const Y = [...u, ...C];
        P(Y), A && A(C, Y), $.next ? D($, r) : (v && v(), I(!1));
      });
    }, n);
    E(l);
  }, [m, u, s, y, e, v, S, A, t, n]);
  return X(() => (L.current = !0, () => {
    L.current = !1, f.current?.abort();
  }), []), [T, u, D, a, m];
}, An = ({ getEndpoint: e, preflightValidation: t, pageLimit: s = 100, chunkLimit: n = 2, requestDelay: A = 500, onUpdate: v, onComplete: S, onFailure: y }, L) => {
  const f = Ne(), p = re(!1), E = re(), [T, I] = G(!1), [a, _] = G(!1), u = re([]), [P, m] = G(), [D, i] = G(), [r, d] = G(0), h = b((w) => {
    p.current && (u.current.push(...w), v && v(w, u.current), m([...u.current]));
  }, [v]), o = b((w) => {
    if (p.current) return Array.isArray(w) || w.isError ? (y && y(w), console.debug(w), i(w), _(!0), void I(!1)) : void (w.isError || (console.error("DRAIN request handling non-error in Error handler", w), _(!0), I(!1)));
  }, [y]), l = b(() => {
    S && S(), _(!0), I(!1);
  }, [S]), [c, g, U, C, $] = Ft({ getEndpoint: e, pageLimit: s, chunkLimit: n, requestDelay: A, onUpdate: h, onComplete: l, onFailure: o }), Y = b(() => {
    E.current && E.current.abort(), $();
  }, [$]), J = b((w) => (W) => {
    if (p.current) if (W.isError) o(W);
    else {
      if (u.current = [...W.data.results], d(W.data.count), m(u.current), !W.data.next) return _(!0), void I(!1);
      U(W.data, w);
    }
  }, [U, o]), ue = b((w, W = !0) => {
    if (W && Y(), I(!0), _(!1), d(0), u.current = [], !(!t || t(w)))
      return void o({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "PreflightValidation", message: "GET request did not pass preflight validation" } });
    const ie = e(w);
    if (!ie)
      return void o({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "MalformedURL", message: "unable to DRAIN: url is missing" } });
    const he = qe(w.query), Te = J(w);
    E.current = new AbortController();
    const ge = { ...w, url: he ? `${ie}${he}` : ie, method: N.GET, signal: E.current.signal };
    i(void 0), f(ge).then(Te, o).catch(o);
  }, [Y, f, e, o, J, t]);
  return X(() => {
    p.current = !0;
    const w = E.current?.abort;
    return () => {
      p.current = !1, w && w();
    };
  }, []), X(() => {
    !L || T || P || D || C || ue(L);
  }, [C, P, ue, D, L, T]), [T || c, a, P, r, ue, D || C];
}, O = ({ getEndpoint: e, preflightValidation: t, formatQuery: s, onSuccess: n, onFailure: A, method: v, authRequired: S = !0, tenantRequired: y = !0, headers: L }, f) => {
  const p = Ne(), E = re(!1), T = re(), [I, a] = G(!1), [_, u] = G(), [P, m] = G(), D = b((d) => {
    if (E.current) {
      if (d.isError) return A && A(d), m(d), void a(!1);
      if (n) {
        const h = n(d.data);
        u(h || d.data);
      } else u(d.data);
      a(!1);
    }
  }, [A, n]), i = b((d) => {
    console.debug(d), E.current && (d.isError && (m(d), A && A(d)), a(!1));
  }, [A]);
  b((d) => {
    T.current?.abort(d);
  }, []);
  const r = b((d, h = !0) => {
    const o = e(d);
    if (!o)
      return void console.warn({ error_code: "MalformedURL", message: "unable to send GET request: url is missing" }, d);
    const { params: l, query: c, body: g, ...U } = d;
    let C;
    if (typeof d.params != "boolean") {
      if (!(!t || t({ params: l, query: c, body: g })))
        return void console.warn({ error_code: "PreflightValidation", message: "GET request did not pass preflight validation" }, d);
      const Y = c ? s ? s(c) : c : void 0;
      C = { ...U, url: Y ? `${o}${qe(Y)}` : o, method: v, body: g, authRequired: S, tenantRequired: y, headers: L };
    } else C = { url: o, method: v, authRequired: S, tenantRequired: y, headers: L };
    h && T.current?.abort();
    const $ = new AbortController();
    C.signal = $.signal, u(void 0), m(void 0), T.current = $, a(!0), p(C).then(D, i).catch(i);
  }, [e, p, D, i, t, s, v, S, y, L]);
  return X(() => {
    E.current = !0;
    const d = T.current?.abort;
    return () => {
      E.current = !1, d && d();
    };
  }, []), X(() => {
    !f || I || _ || P || (typeof f.params != "boolean" || f.params) && r(f);
  }, [_, P, r, f, I]), ae(() => [I, _, r, P], [I, _, r, P]);
}, Mt = (e, t) => e >= 200 && e <= 209 || e >= 300 && e <= 308 || (e >= 400 && e <= 429 ? (console.warn(t), !0) : e >= 500 && e <= 511 ? (console.error(t), !0) : (console.debug("unhandled HTTP Status"), console.error(t), !1)), Yt = ({ params: e }) => `https://stg.hivery.ai/api/v1/agent/assistants${e?.assistantId ? `/${e?.assistantId}` : ""}`, wt = { id: "ParamsGetAgentAssistants", type: "object", properties: { assistantId: { type: "string", required: !0 } }, required: !1 }, jt = ({ params: e }) => H(wt, e), In = (e, t) => O({ ...t, method: N.GET, getEndpoint: Yt, preflightValidation: jt }, e), Kt = ({ params: e }) => {
  const t = { ENV: "staging", HIVEMIND_ENV: "stg.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://stg.hivery.ai/api/v1/curate", CURATE_API_V2: "https://stg.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://stg.hivery.ai/api/v1/ie", PREDICTION_API: "https://stg.hivery.ai/api/v1/prediction", SSDI_API: "https://stg.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://stg.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://stg.hivery.ai/api/v1/strategies", AGENT_API: "https://stg.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "gSrXJ9P8FvZdua2q1gYqswVOJqQqRpdd", AUTH0_DOMAIN: "auth.stg.hivery.ai", AUTH0_AUDIENCE: "propel-api-staging", PUSHER_APP_KEY: "ed81ada4152f5becc720", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "ed81ada4152f5becc720", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://stg.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.stg.hivery.ai" };
  if (e?.threadId && e?.messageId) return `${t.AGENT_API}/threads/${e.threadId}/messages/${e.messageId}`;
}, $t = { id: "ParamsGetAgentMessage", type: "object", properties: { threadId: { type: "string", required: !0 }, messageId: { type: "string", required: !0 } }, required: !1 }, Zt = ({ params: e }) => H($t, e), gn = (e, t) => O({ ...t, method: N.GET, getEndpoint: Kt, preflightValidation: Zt }, e), Jt = ({ params: e }) => {
  const t = { ENV: "staging", HIVEMIND_ENV: "stg.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://stg.hivery.ai/api/v1/curate", CURATE_API_V2: "https://stg.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://stg.hivery.ai/api/v1/ie", PREDICTION_API: "https://stg.hivery.ai/api/v1/prediction", SSDI_API: "https://stg.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://stg.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://stg.hivery.ai/api/v1/strategies", AGENT_API: "https://stg.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "gSrXJ9P8FvZdua2q1gYqswVOJqQqRpdd", AUTH0_DOMAIN: "auth.stg.hivery.ai", AUTH0_AUDIENCE: "propel-api-staging", PUSHER_APP_KEY: "ed81ada4152f5becc720", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "ed81ada4152f5becc720", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://stg.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.stg.hivery.ai" };
  if (e?.threadId && e?.runId) return `${t.AGENT_API}/threads/${e.threadId}/runs/${e.runId}`;
}, xt = { id: "ParamsGetAgentRun", type: "object", properties: { threadId: { type: "string", required: !0 }, runId: { type: "string", required: !0 } }, required: !1 }, zt = ({ params: e }) => H(xt, e), Sn = (e, t) => O({ ...t, method: N.GET, getEndpoint: Jt, preflightValidation: zt }, e), kt = ({ params: e }) => `https://stg.hivery.ai/api/v1/agent/threads${e?.threadId ? `/${e?.threadId}` : ""}`, Wt = { id: "ParamsGetAgentThreads", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, Qt = ({ params: e }) => H(Wt, e), Tn = (e, t) => O({ ...t, method: N.GET, getEndpoint: kt, preflightValidation: Qt }, e), Bt = ({ params: e }) => {
  const t = { ENV: "staging", HIVEMIND_ENV: "stg.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://stg.hivery.ai/api/v1/curate", CURATE_API_V2: "https://stg.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://stg.hivery.ai/api/v1/ie", PREDICTION_API: "https://stg.hivery.ai/api/v1/prediction", SSDI_API: "https://stg.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://stg.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://stg.hivery.ai/api/v1/strategies", AGENT_API: "https://stg.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "gSrXJ9P8FvZdua2q1gYqswVOJqQqRpdd", AUTH0_DOMAIN: "auth.stg.hivery.ai", AUTH0_AUDIENCE: "propel-api-staging", PUSHER_APP_KEY: "ed81ada4152f5becc720", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "ed81ada4152f5becc720", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://stg.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.stg.hivery.ai" };
  if (e?.threadId) return `${t.AGENT_API}/threads/${e.threadId}/messages`;
}, Xt = { id: "ParamsListAgentMessages", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, er = { id: "QueryListAgentMessages", type: "object", properties: { limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 } }, required: !1 }, tr = ({ params: e, query: t }) => {
  const s = H(Xt, e);
  return s && ne(er, t);
}, vn = (e, t) => O({ ...t, method: N.GET, getEndpoint: Bt, preflightValidation: tr }, e), rr = { SINGLE: "single_agent_assistant" }, ar = { SCENARIO: "scenario" }, ir = { USER: "user", ASSISTANT: "assistant" }, Pn = { IN_PROGRESS: "in_progress", INCOMPLETE: "incomplete", COMPLETED: "completed" }, ln = { DIALOGUE: "dialogue", MONOLOGUE: "monologue", CHART: "chart" }, yn = { NOMINAL: "nominal" }, mn = { BAR: "bar" }, Rn = { SVG: "image/svg+xml", HTML: "image/html" }, fn = { QUEUED: "queued", IN_PROGRESS: "in_progress", FAILED: "failed", COMPLETED: "completed" }, sr = () => "https://stg.hivery.ai/api/v1/agent/assistants", nr = { id: "BodyPostAgentAssistant", type: "object", properties: { assistantConfig: { type: "object", required: !0, additionalProperties: !1, properties: { assistantType: { type: "string", required: !0, enum: [rr.SINGLE] } } }, description: { type: "string" } }, required: !0 }, or = ({ body: e }) => B(nr, e), Un = (e) => O({ ...e, method: N.POST, getEndpoint: sr, preflightValidation: or }), pr = ({ params: e }) => {
  const t = { ENV: "staging", HIVEMIND_ENV: "stg.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://stg.hivery.ai/api/v1/curate", CURATE_API_V2: "https://stg.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://stg.hivery.ai/api/v1/ie", PREDICTION_API: "https://stg.hivery.ai/api/v1/prediction", SSDI_API: "https://stg.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://stg.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://stg.hivery.ai/api/v1/strategies", AGENT_API: "https://stg.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "gSrXJ9P8FvZdua2q1gYqswVOJqQqRpdd", AUTH0_DOMAIN: "auth.stg.hivery.ai", AUTH0_AUDIENCE: "propel-api-staging", PUSHER_APP_KEY: "ed81ada4152f5becc720", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "ed81ada4152f5becc720", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://stg.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.stg.hivery.ai" };
  if (e?.threadId) return `${t.AGENT_API}/threads/${e.threadId}/messages`;
}, Er = { id: "ParamsPostAgentMessage", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, dr = { id: "BodyPostAgentMessage", type: "object", properties: { content: { type: "string", required: !0 }, role: { type: "string", required: !0, enum: [ir.USER] } }, required: !0 }, _r = ({ params: e, body: t }) => {
  const s = H(Er, e);
  return s && B(dr, t);
}, Nn = (e) => O({ ...e, method: N.POST, getEndpoint: pr, preflightValidation: _r }), ur = ({ params: e }) => {
  const t = { ENV: "staging", HIVEMIND_ENV: "stg.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://stg.hivery.ai/api/v1/curate", CURATE_API_V2: "https://stg.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://stg.hivery.ai/api/v1/ie", PREDICTION_API: "https://stg.hivery.ai/api/v1/prediction", SSDI_API: "https://stg.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://stg.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://stg.hivery.ai/api/v1/strategies", AGENT_API: "https://stg.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "gSrXJ9P8FvZdua2q1gYqswVOJqQqRpdd", AUTH0_DOMAIN: "auth.stg.hivery.ai", AUTH0_AUDIENCE: "propel-api-staging", PUSHER_APP_KEY: "ed81ada4152f5becc720", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "ed81ada4152f5becc720", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://stg.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.stg.hivery.ai" };
  if (e?.threadId) return `${t.AGENT_API}/threads/${e.threadId}/runs`;
}, hr = { id: "ParamsPostAgentRun", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, cr = { id: "ParamsPostAgentRun", type: "object", properties: { assistantId: { type: "string", required: !1 }, asyncMode: { type: "boolean", required: !1 } }, required: !1 }, Ar = ({ params: e, body: t }) => {
  const s = H(hr, e);
  return s && B(cr, t);
}, On = (e) => O({ ...e, method: N.POST, getEndpoint: ur, preflightValidation: Ar }), Ir = () => "https://stg.hivery.ai/api/v1/agent/threads", gr = { id: "BodyPostAgentThread", type: "object", properties: { scope: { type: "object", required: !0, additionalProperties: !1, properties: { scopeLevel: { type: "string", required: !0, enum: [ar.SCENARIO] }, tenantSlug: { type: "string", required: !0 }, projectId: { type: "number", required: !0 }, scenarioId: { type: "number", required: !0 } } } }, required: !0 }, Sr = ({ body: e }) => B(gr, e), Ln = (e) => O({ ...e, method: N.POST, getEndpoint: Ir, preflightValidation: Sr }), Tr = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/assortment`;
}, vr = { id: "ParamsGetAssortment", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Pr = ({ params: e }) => H(vr, e), Cn = (e, t) => O({ ...t, method: N.GET, getEndpoint: Tr, preflightValidation: Pr }, e), lr = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/pods`;
}, yr = { id: "ParamsGetPODS", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, mr = ({ params: e, query: t }) => {
  const s = H(yr, e);
  if (!s) return s;
  const n = ["product_id", "store_id"];
  return t ? t.fields = t.fields ? [...n, ...t.fields] : n : t = { fields: n }, !0;
}, Dn = (e, t) => O({ ...t, method: N.GET, getEndpoint: lr, preflightValidation: mr }, e), Rr = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/tasks/${e.taskId}/status`;
}, fr = { id: "ParamsGetTasksStatus", type: "object", properties: { taskId: { type: "integer", required: !0 } }, required: !0 }, Ur = ({ params: e }) => H(fr, e), Nr = (e, t) => O({ ...t, method: N.GET, getEndpoint: Rr, preflightValidation: Ur }, e);
var le = ((e) => (e.COMPLETED = "COMPLETED", e.PENDING = "PENDING", e.CANCELLED = "CANCELLED", e.STARTED = "STARTED", e.ERROR = "ERROR", e))(le || {});
const At = () => {
  const e = re(), [t, s] = G(!1), [n, A] = G(), [v, S] = G(), [y, L] = G(!1), f = b((_) => {
    if (!n || !n.params)
      return S({ isError: !0, data: { type: "process-error", error_code: "ValidationError", status_code: -1, message: "unable to continue polling task status: request params missing", response: _ } }), s(!1), _;
    switch (_.status) {
      case le.ERROR:
      case le.CANCELLED: {
        const u = { isError: !0, data: { type: "process-error", error_code: "ServerError", status_code: -1, message: `unable to continue polling task status: task resulted in ${_.status}: ${n.params.taskId}`, response: _ } };
        S(u), s(!1);
        break;
      }
      case le.COMPLETED:
        s(!1);
        break;
      case le.PENDING:
      case le.STARTED:
        L(!0);
    }
    return _;
  }, [n]), p = b((_) => {
    S(_), s(!1);
  }, []), [E, T, I] = Nr(void 0, { onSuccess: f, onFailure: p }), a = b((_) => {
    s(!0), A(_), I(_);
  }, [I]);
  return X(() => {
    y && n && (L(!1), e.current = setTimeout(() => {
      I(n);
    }, 5e3));
  }, [I, y, n]), X(() => {
    const _ = e.current;
    return () => {
      _ && clearTimeout(_);
    };
  }, []), [t, T, a, v];
}, Or = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/stores/export_assortment`;
}, Lr = { id: "ParamsExportAssortment", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Cr = ({ params: e }) => H(Lr, e), Hn = () => {
  const [e, t] = G(!1), [s, n] = G(), [A, v] = G(), [S, y, L, f] = At(), p = b((u) => {
    if (typeof u == "string") n(u), t(!1);
    else if (u instanceof Object && Object.hasOwn(u, "taskId")) L({ params: { taskId: u.taskId } });
    else {
      const P = { isError: !0, data: { type: "process-error", error_code: "UnknownResponse", status_code: -1, message: "unknown response type from posting assortment request", response: u } };
      v(P), console.warn(P);
    }
    return u;
  }, [L]), E = b((u) => {
    v(u), t(!1);
  }, []), [T, I, a] = O({ method: N.POST, getEndpoint: Or, preflightValidation: Cr, onSuccess: p, onFailure: E }), _ = b((u) => {
    t(!0), a({ ...u, body: void 0 });
  }, [a]);
  return X(() => {
    S || (f ? console.warn(f) : (n(y), t(!1)));
  }, [S, y, f]), ae(() => [e, s, _, A], [A, s, e, _]);
};
var Dr = ((e) => (e.ADDED = "added", e.REMOVED = "removed", e.RETAINED = "retained", e.EXCLUDED = "excluded", e))(Dr || {});
const Hr = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}`;
}, Vr = { id: "ParamsGetDocuments", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, br = ({ params: e }) => H(Vr, e), Vn = (e, t) => O({ ...t, method: N.GET, getEndpoint: Hr, preflightValidation: br }, e), Gr = ({ params: e, query: t }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/workspaces/${e.workspaceId}/documents/summaries`;
}, qr = { id: "ParamsGetDocumentsSummaries", type: "object", properties: { workspaceId: { type: "integer", required: !0 } }, required: !0 }, Fr = ({ params: e, query: t }) => H(qr, e), bn = (e, t) => O({ ...t, method: N.GET, getEndpoint: Gr, preflightValidation: Fr }, e);
var Mr = ((e) => (e.READY = "READY", e.BUSY = "BUSY", e))(Mr || {});
const Yr = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/edit_requests/most_recent`;
}, wr = { id: "ParamsGetEditRequestsMostRecent", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, jr = ({ params: e }) => H(wr, e), Kr = (e, t) => O({ ...t, method: N.GET, getEndpoint: Yr, preflightValidation: jr }, e);
var we = ((e) => (e.pending = "PENDING", e.error = "ERROR", e.completed = "COMPLETED", e))(we || {}), _e = ((e) => (e.drop = "DROP_POSITION", e.dropProduct = "DROP_PRODUCT", e.insert = "INSERT_POSITION", e.insertProduct = "INSERT_PRODUCT", e.move = "MOVE_POSITION", e.setFacings = "SET_POSITION_FACINGS", e.setProduct = "SET_POSITION_PRODUCT", e.swap = "SWAP_POSITION", e.swapProduct = "SWAP_PRODUCT", e.insertProductBulk = "INSERT_POSITION_BULK", e.dropPositionBulk = "DROP_POSITION_BULK", e))(_e || {});
const $r = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/edit_requests`;
}, Zr = { id: "ParamsPostEditRequestsCreate", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Jr = ({ params: e }) => H(Zr, e), Ie = () => {
  const [e, t] = G(!1), [s, n] = G(), [A, v] = G(), S = b((m) => {
    n(m), t(!1);
  }, []), y = b((m) => (t(!1), m), []), [L, f, p, E] = O({ method: N.POST, getEndpoint: $r, preflightValidation: Jr, onFailure: S, onSuccess: y }), T = b((m) => {
    switch (m.status) {
      case we.completed:
        if (!A || !A.body) {
          n({ isError: !0, data: { type: "process-error", error_code: "ValidationError", status_code: -1, message: "unable to create edit request: edit request data is missing" } }), t(!1);
          break;
        }
        p({ ...A, body: { ...A.body, version: m.version + 1 } }), t(!1);
        break;
      case we.error:
        n({ isError: !0, data: { type: "process-error", error_code: "ServerError", status_code: -1, message: "unable to create edit request: most recent request encountered an error", response: m } }), t(!1);
        break;
    }
    return m;
  }, [p, A]), [I, a, _, u] = Kr(void 0, { onFailure: S, onSuccess: T }), P = b((m) => {
    m.params ? (t(!0), n(void 0), v(m), _({ params: { documentId: m.params.documentId } })) : console.debug("unable to send edit request: params missing");
  }, [_]);
  return ae(() => [e, f, P, s], [f, s, e, P]);
}, Gn = () => {
  const [e, t, s, n] = Ie(), A = b(({ params: v, body: S }) => {
    if (!v || !S) return;
    const y = { version: 1, commandType: _e.drop, parameters: S };
    s({ params: v, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, A, n], [e, A, t, n]);
}, qn = () => {
  const [e, t, s, n] = Ie(), A = b(({ params: v, body: S }) => {
    if (!v || !S) return;
    const y = { version: 1, commandType: _e.dropProduct, parameters: S };
    s({ params: v, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, A, n], [e, A, t, n]);
}, Fn = () => {
  const [e, t, s, n] = Ie(), A = b(({ params: v, body: S }) => {
    if (!v || !S) return;
    const y = { version: 1, commandType: _e.insert, parameters: S };
    s({ params: v, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, A, n], [e, A, t, n]);
}, Mn = () => {
  const [e, t, s, n] = Ie(), A = b(({ params: v, body: S }) => {
    if (!v || !S) return;
    const y = { version: 1, commandType: _e.insertProduct, parameters: S };
    s({ params: v, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, A, n], [e, A, t, n]);
}, Yn = () => {
  const [e, t, s, n] = Ie(), A = b(({ params: v, body: S }) => {
    if (!v || !S) return;
    const y = { version: 1, commandType: _e.move, parameters: S };
    s({ params: v, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, A, n], [e, A, t, n]);
}, wn = () => {
  const [e, t, s, n] = Ie(), A = b(({ params: v, body: S }) => {
    if (!v || !S) return;
    const y = { version: 1, commandType: _e.setFacings, parameters: S };
    s({ params: v, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, A, n], [e, A, t, n]);
}, jn = () => {
  const [e, t, s, n] = Ie(), A = b(({ params: v, body: S }) => {
    if (!v || !S) return;
    const y = { version: 1, commandType: _e.swap, parameters: S };
    s({ params: v, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, A, n], [e, A, t, n]);
}, Kn = () => {
  const [e, t, s, n] = Ie(), A = b(({ params: v, body: S }) => {
    if (!v || !S) return;
    const y = { version: 1, commandType: _e.swapProduct, parameters: S };
    s({ params: v, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, A, n], [e, A, t, n]);
}, xr = () => "https://stg.hivery.ai/api/v2/ssdi/test-auth", $n = (e, t) => O({ ...t, method: N.GET, getEndpoint: xr }, e), It = { MOVEMENT: "movement", PRODUCT: "product", PRODUCT_INNOVATIONS: "product_innovations", LOCATION: "location", LOCATION_INNOVATIONS: "location_innovations", LOCATION_PLANOGRAMS: "location_planograms", AVAILABILITY: "availability", PLANOGRAMS: "planograms" }, Zn = { PENDING: "pending", RESOLVING: "resolving", SUCCEEDED: "succeeded", FAILED: "failed", CANCELLED: "cancelled" }, zr = () => "https://stg.hivery.ai/api/v2/ssdi/files", kr = { id: "BodyPostFilesUpload", type: "object", properties: { kind: { type: "string", required: !0, enum: Object.values(It) }, name: { type: "string", required: !0 } }, required: !0 }, Wr = ({ body: e }) => B(kr, e), Qr = (e) => O({ ...e, method: N.POST, getEndpoint: zr, preflightValidation: Wr }), Br = ({ params: e }) => {
  if (e) return `https://stg.hivery.ai/api/v2/ssdi/files/${e.id}/upload-complete`;
}, Xr = { id: "ParamsPostFilesUploadComplete", type: "object", properties: { id: { type: "string", required: !0 } }, required: !1 }, ea = { id: "BodyPostFilesUploadComplete", type: "object", properties: { filePartIds: { type: "array", required: !0, minItems: 1, items: { type: "string" }, additionalItems: !1 }, kind: { type: "string", required: !0, enum: Object.values(It) }, ext: { type: "string", required: !0 } }, required: !0 }, ta = ({ params: e, body: t }) => {
  const s = H(Xr, e);
  return s && B(ea, t);
}, ra = (e) => O({ ...e, method: N.POST, getEndpoint: Br, preflightValidation: ta }), aa = ({ params: e }) => {
  if (e) return `https://stg.hivery.ai/api/v2/ssdi/files/${e.id}/upload-part/${e.part_number}`;
}, ia = { id: "ParamsPostFilesUploadPart", type: "object", properties: { id: { type: "string", required: !0 }, part_number: { type: "number", required: !0 } }, required: !1 }, sa = ({ params: e }) => H(ia, e), na = (e) => {
  let t = { "Content-Type": "multipart/form-data" };
  return e && e.headers && (t = { ...e.headers, ...t }, delete e.headers), Gt({ ...e, method: N.POST, getEndpoint: aa, preflightValidation: sa, headers: t });
}, oa = () => "https://stg.hivery.ai/api/v1/curate/preferences", Jn = (e = !0, t) => O({ ...t, method: N.GET, getEndpoint: oa, tenantRequired: !1 }, { params: e }), pa = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/products/${e.productId}`;
}, Ea = { id: "ParamsGetCurateProduct", type: "object", properties: { productId: { type: "integer", required: !0 } }, required: !0 }, da = ({ params: e }) => {
  const t = H(Ea, e);
  return !!t || t;
}, xn = (e, t) => O({ ...t, method: N.GET, getEndpoint: pa, preflightValidation: da }, e), _a = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/scenarios/${e.scenarioId}/national-results`;
}, ua = { id: "ParamsGetCurateProductSummaries", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, ha = { id: "QueryGetCurateProductSummaries", type: "object", properties: { ordering: { type: "string", required: !0 }, "group-by": { type: "string" } }, required: !0 }, ca = ({ params: e, query: t }) => {
  const s = H(ua, e);
  if (!s) return s;
  const n = ne(ha, t);
  return !!n || n;
}, zn = (e, t) => O({ ...t, method: N.GET, getEndpoint: _a, preflightValidation: ca }, e), Aa = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/scenarios/${e.scenarioId}/cannibalisation/product`;
}, Ia = { id: "ParamsGetProductDemandTransfer", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, ga = { id: "QueryGetCurateProductSummaries", type: "object", properties: { mode: { type: "string", required: !0 }, upc: { type: "integer", required: !0 }, store_id: { type: "integer", required: !0 } }, required: !0 }, Sa = ({ params: e, query: t }) => {
  const s = H(Ia, e);
  if (!s) return s;
  const n = ne(ga, t);
  return !!n || n;
}, kn = (e, t) => O({ ...t, method: N.GET, getEndpoint: Aa, preflightValidation: Sa }, e), Ta = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/products/summaries`;
}, va = { id: "ParamsGetProductSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Pa = { id: "QueryGetProductSummaries", type: "object", properties: { group_by: { type: "string", required: !0, minLength: 1 } }, required: !0 }, la = ({ params: e, query: t }) => {
  const s = H(va, e);
  if (!s) return s;
  const n = ne(Pa, t);
  return !!n || n;
}, Wn = (e, t) => O({ ...t, method: N.GET, getEndpoint: Ta, preflightValidation: la }, e), ya = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/projects/${e.projectId}/products${e.productId ? `/${e.productId}` : ""}`;
}, ma = { id: "ParamsGetProducts", type: "object", properties: { projectId: { type: "integer", required: !0 }, productId: { type: "integer", required: !1 } }, required: !0 }, Ra = ({ params: e }) => H(ma, e), Qn = (e, t) => O({ ...t, method: N.GET, getEndpoint: ya, preflightValidation: Ra }, e), fa = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/projects/${e.projectId}`;
}, Ua = { id: "ParamsDeleteProjects", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Na = ({ params: e }) => H(Ua, e), Bn = (e, t) => O({ ...t, method: N.DELETE, getEndpoint: fa, preflightValidation: Na }, e), Oa = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/data-details`;
}, La = { id: "ParamsGetProjectDataDetails", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Ca = ({ params: e }) => H(La, e), Xn = (e, t) => O({ ...t, method: N.GET, getEndpoint: Oa, preflightValidation: Ca }, e);
var Da = ((e) => (e.SUCCESS = "success", e.PENDING = "pending", e.PROCESSING = "processing", e.FAILED = "failed", e))(Da || {}), Ue = ((e) => (e.PSA = "PSA", e.PTS = "PTS", e))(Ue || {});
const ot = { UPDATED_ASC: "+updated_on", UPDATED_DES: "-updated_on" }, Ha = { FORECASTS: "forecasts", PRODUCTS: "products", STORES: "stores", SUPPLIERS: "suppliers", PLANOGRAMS: "planograms", C13NS: "c13ns" }, eo = { PENDING: "pending", SUCCESS: "success", UNKNOWN: "", DONE: "done", PROCESSING: "processing" }, Va = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/projects/${e.projectId}/export-url/${e.fileType}`;
}, ba = { id: "ParamsGetProjectExportUrl", type: "object", properties: { projectId: { type: "integer", required: !0 }, fileType: { type: "string", required: !0, enum: Object.values(Ha) } }, required: !0 }, Ga = ({ params: e }) => H(ba, e), to = (e, t) => O({ ...t, method: N.GET, getEndpoint: Va, preflightValidation: Ga }, e), qa = () => "https://stg.hivery.ai/api/v1/curate/projects/file-upload-config", ro = (e = !0, t) => O({ ...t, method: N.GET, getEndpoint: qa }, { params: e }), Fa = ({ params: e }) => `https://stg.hivery.ai/api/v1/curate/projects${e?.projectId ? `/${e?.projectId}` : ""}`, Ma = { id: "ParamsGetProjects", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !1 }, Ya = { id: "QueryGetProjects", type: "object", properties: { search: { type: "string", required: !1 }, limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 }, ordering: { type: "string", required: !0, enum: [ot.UPDATED_ASC, ot.UPDATED_DES] } }, required: !1 }, wa = ({ params: e, query: t }) => e && Object.hasOwn(e, "projectId") ? H(Ma, e) : ne(Ya, t), ao = (e, t) => O({ ...t, method: N.GET, getEndpoint: Fa, preflightValidation: wa }, e), ja = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/projects/${e.projectId}`;
}, Ka = { id: "ParamsPatchProject", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, $a = { id: "BodyPatchProject", type: "object", properties: { isArchive: { type: "boolean", required: !0 } } }, Za = ({ params: e, body: t }) => {
  const s = H(Ka, e);
  if (!s) return s;
  const n = B($a, t);
  return !!n || n;
}, io = (e) => O({ ...e, method: N.PATCH, getEndpoint: ja, preflightValidation: Za }), Ja = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/settings`;
}, xa = { id: "ParamsPatchProjectSettings", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, za = { id: "BodyPatchProjectSettings", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 }, storesFile: { type: "string", required: !0, minLength: 1 }, productsFile: { type: "string", required: !0, minLength: 1 }, forecastsFile: { type: "string", required: !0, minLength: 1 }, suppliersFile: { type: "string", required: !0, minLength: 1 }, planogramsFile: { type: "string", required: !0, minLength: 0 }, planogramsFileFormat: { type: "string", enum: [Ue.PSA, Ue.PTS] }, planogramsFileNamingConvention: { type: "string", required: !0, minLength: 0 }, c13nsFile: { type: "string", required: !0, minLength: 0 }, changeC13nsFile: { type: "boolean", required: !0 } } }, ka = ({ params: e, body: t }) => {
  const s = H(xa, e);
  if (!s) return s;
  const n = B(za, t);
  return !!n || n;
}, so = (e) => O({ ...e, method: N.PATCH, getEndpoint: Ja, preflightValidation: ka }), pt = { SPACE: "space", ASSORTMENT: "assortment" }, no = { FORCE_PODS_IN: "force_pods_in", FORCE_PODS_OUT: "force_pods_out", POD_PRESENCE: "pod_presence", TARGET_PODS: "target_pods", TARGET_QUANTITY_SOLD: "target_quantity_sold", TARGET_REVENUE: "target_revenue", TARGET_DISTRIBUTION: "target_distribution", TARGET_PRODUCT_SLOTTING: "target_product_slotting", PROTECT_PODS: "protect_pods", PARENT_RELATIONSHIP: "parent_relationship", LIMIT_ASSORTMENT_CHURN: "limit_assortment_churn", SPECIFY_ASSORTMENT_PRIORITY: "specify_assortment_priority" }, oo = { ADJUST_AVAILABILITY: "adjust_availability", ADJUST_QUANITY_SOLD: "adjust_quantity_sold", ADJUST_REVENUE: "adjust_revenue", ADJUST_RANKING_PRIORITY: "adjust_ranking_priority", ADJUST_OBJECTIVE_VALUE: "adjust_objective_value" }, po = { SPECIFY_UNIT_CAPACITY: "specify_unit_capacity", SPECIFTY_CASE_CAPACITY: "specify_case_capacity", RESTRICT_UNSALEABLES: "restrict_unsaleables", SPECIFY_DOS_THRESHOLD: "specify_dos_threshold", DOS_BOOST: "dos_boost", CONTROL_FACINGS_FOR_ORIENTATION: "control_facings_for_orientation", LIMIT_SPACE_CHURN: "limit_space_churn", SPACE_ALLOCATION: "space_allocation" }, Eo = { MATCH_PLACEMENT_HIERARCHICAL: "match_placement_hierarchical", ALLOWABLE_FIXTURE_TYPES: "allowable_fixture_types", ORIENTATIONS_FOR_MERCH_STYLE: "orientations_for_merch_style", SPECIFY_HEIGHT_FOR_STYLE: "specify_height_for_style", MAXIMUM_STACK_HEIGHT_FOR_STYLE: "maximum_stack_height_for_style", ALLOWED_MERCHANDIZE_STYLES: "allowed_merchandise_styles", SPECIFY_PLACEMENT_RANGE: "specify_placement_range" }, _o = { RELATIVE_POSITIONING: "relative_positioning", SINGLE_SHELF: "single_shelf", SINGLE_SEGMENT: "single_segment", SINGLE_LEVEL: "single_level", DISALLOW_PRESENCE: "disallow_presence", CHAIN_FLOW: "chain_flow", CONTROL_ALIGNMENT: "control_alignment", CONTROL_OVER_UNDERS: "control_over_unders" }, Wa = () => "https://stg.hivery.ai/api/v1/curate/projects", Qa = { id: "BodyPostProject", type: "object", properties: { algorithmTypes: { type: "array", required: !0, minItems: 1, items: { type: "string", enum: [pt.ASSORTMENT, pt.SPACE] }, additionalItems: !1 }, name: { type: "string", required: !0, minLength: 1 }, storesFile: { type: "string", required: !0, minLength: 1 }, productsFile: { type: "string", required: !0, minLength: 1 }, forecastsFile: { type: "string", required: !0, minLength: 1 }, suppliersFile: { type: "string", required: !0, minLength: 1 }, planogramsFile: { type: "string", required: !0, minLength: 0 }, planogramsFileFormat: { type: "string", enum: [Ue.PSA, Ue.PTS] }, planogramsFileNamingConvention: { type: "string", required: !0, minLength: 0 }, c13nsFile: { type: "string", required: !0, minLength: 0 }, c13nModelId: { type: "string", required: !0, minLength: 0 }, isCannibalisationOnly: { type: "boolean", required: !0 }, parameters: { type: "object", required: !0, properties: { podThresholds: { type: "string", required: !0, minLength: 0 }, productFlow: { type: "string", required: !0, minLength: 0 }, rankingWeights: { type: "string", required: !0, minLength: 0 } }, additionalProperties: !1 } } }, Ba = ({ body: e }) => B(Qa, e), uo = (e) => O({ ...e, method: N.POST, getEndpoint: Wa, preflightValidation: Ba }), Xa = () => "https://stg.hivery.ai/api/v1/curate/constraint-types", ei = { id: "QueryGetConstraintTypes", type: "object", properties: { algorithm_types: { type: "string", required: !0 } }, required: !1 }, ti = ({ query: e }) => ne(ei, e), ho = (e, t) => O({ ...t, method: N.GET, getEndpoint: Xa, preflightValidation: ti }, e), ri = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios/${e.scenarioId}`;
}, ai = { id: "ParamsDeleteScenario", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, ii = ({ params: e }) => H(ai, e), co = (e, t) => O({ ...t, method: N.DELETE, getEndpoint: ri, preflightValidation: ii }, e), si = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/reviews${e.reviewId ? `/${e.reviewId}` : ""}`;
}, ni = { id: "ParamsGetReviews", type: "object", properties: { reviewId: { type: "integer", required: !1 } }, required: !1 }, oi = ({ params: e }) => H(ni, e), Ao = (e, t) => O({ ...t, method: N.GET, getEndpoint: si, preflightValidation: oi }, e), pi = () => "https://stg.hivery.ai/api/v1/curate/scenarios/aggregation-options", Io = (e = !0, t) => O({ ...t, method: N.GET, getEndpoint: pi }, { params: e }), Ei = () => "https://stg.hivery.ai/api/v1/curate/scenarios/file-upload-config", go = (e = !0, t) => O({ ...t, method: N.GET, getEndpoint: Ei }, { params: e }), di = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenario-groups${e.groupId ? `/${e.groupId}` : ""}`;
}, _i = { id: "ParamsGetScenarioGroups", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !1 } }, required: !0 }, ui = ({ params: e }) => H(_i, e), So = (e, t) => O({ ...t, method: N.GET, getEndpoint: di, preflightValidation: ui }, e);
var hi = ((e) => (e.SUCCESS = "success", e.SUCCESS_WITH_INFEASIBILITY = "success_with_inf", e.UNOPTIMISED = "unoptimised", e.PEDNING = "pending", e.PROCESSING = "processing", e.PROCESSING_UNPOLLABLE = "processing_unpollable", e.FAILED = "failed", e))(hi || {}), ci = ((e) => (e.JOB_QUEUED = "job_queued", e.LOADING_DATA = "loading_data", e.SOLVING_MODEL = "solving_model", e.SAVING_RESULTS = "saving_results", e.PROCESSING = "processing", e.FAILED = "failed", e))(ci || {}), Ai = ((e) => (e.RULE = "rules_based", e.IE = "interactive", e))(Ai || {}), Ii = ((e) => (e.IMPORT_PENDING = "import_pending", e.IMPORT_PROCESSING = "import_processing", e.IMPORT_FAILED = "import_failed", e.EDIT_PENDING = "edit_pending", e.EDIT_FAILED = "edit_failed", e.READY = "ready", e.SAVED = "saved", e))(Ii || {});
const be = { PRODUCT_ASC: "product", PRODUCT_DES: "-product", UPC_ASC: "product_upc", UPC_DES: "-product_upc" }, gi = { BRAND: "brand", SUB_BRAND: "subbrand", CATEGORY: "category", SUB_CATEGORY: "subcategory", SUB_SUB_CATEGORY: "subsubcategory", MANUFACTURER: "manufacturer", PACK_GROUP: "packgroup", PRODUCT_UPC: "product_upc", PRODUCT_GROUP: "product_group" }, Si = ({ params: e, query: t }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/scenarios/${e.scenarioId}/national-results`;
}, Ti = { id: "ParamsGetScenariosNationalResults", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, vi = { id: "QueryGetScenariosNationalResults", type: "object", properties: { ordering: { type: "string", required: !1, enum: [be.PRODUCT_ASC, be.PRODUCT_DES, be.UPC_ASC, be.UPC_DES] }, groupings: { type: "array", required: !1, items: { type: "string", uniqueItems: !0, enum: Object.entries(gi).map((e, t) => t) } } } }, Pi = ({ params: e, query: t }) => {
  const s = H(Ti, e);
  if (!s) return s;
  const n = ne(vi, t);
  return !!n || n;
}, li = (e) => {
  const t = {};
  return e.ordering && (t.ordering = e.ordering), e.groupBy && (t["group-by"] = e.groupBy.join(",")), t;
}, To = (e, t) => O({ ...t, method: N.GET, getEndpoint: Si, preflightValidation: Pi, formatQuery: li }, e), yi = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios${e.scenarioId ? `/${e.scenarioId}` : ""}`;
}, mi = { id: "ParamsGetScenarios", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !1 } }, required: !0 }, Ri = ({ params: e }) => H(mi, e), vo = (e, t) => O({ ...t, method: N.GET, getEndpoint: yi, preflightValidation: Ri }, e), fi = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios-base-core`;
}, Ui = { id: "ParamsGetScenariosBaseCore", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Ni = ({ params: e }) => H(Ui, e), Po = (e, t) => O({ ...t, method: N.GET, getEndpoint: fi, preflightValidation: Ni }, e), Oi = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios/${e.reviewId}`;
}, Li = { id: "ParamsPatchReview", type: "object", properties: { projectId: { type: "integer", required: !0 }, reviewId: { type: "integer", required: !0 } }, required: !0 }, Ci = { id: "BodyPatchReview", type: "object", properties: { isArchived: { type: "boolean", required: !0 } } }, Di = ({ params: e, body: t }) => {
  const s = H(Li, e);
  if (!s) return s;
  const n = B(Ci, t);
  return !!n || n;
}, lo = (e) => O({ ...e, method: N.PATCH, getEndpoint: Oi, preflightValidation: Di }), Hi = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios/${e.scenarioId}`;
}, Vi = { id: "ParamsPatchScenario", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, bi = ({ params: e }) => H(Vi, e), yo = (e) => O({ ...e, method: N.PATCH, getEndpoint: Hi, preflightValidation: bi }), Gi = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios/${e.scenarioId}/assign-group`;
}, qi = { id: "ParamsPatchScenarioAssignGroup", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, Fi = { id: "BodyPatchScenarioGroupRename", type: "object", properties: { groupId: { type: "string", required: !0, minLength: 1 } } }, Mi = ({ params: e, body: t }) => {
  const s = H(qi, e);
  if (!s) return s;
  const n = B(Fi, t);
  return !!n || n;
}, mo = (e) => O({ ...e, method: N.PATCH, getEndpoint: Gi, preflightValidation: Mi }), Yi = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenario-groups/${e.groupId}/archive`;
}, wi = { id: "ParamsPatchScenarioGroupArchive", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, ji = ({ params: e }) => H(wi, e), Ro = (e) => O({ ...e, method: N.PATCH, getEndpoint: Yi, preflightValidation: ji }), Ki = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenario-groups/${e.groupId}/undo-archive`;
}, $i = { id: "ParamsPatchScenarioGroupArchiveUndo", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, Zi = ({ params: e }) => H($i, e), fo = (e) => O({ ...e, method: N.PATCH, getEndpoint: Ki, preflightValidation: Zi }), Ji = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenario-groups/${e.groupId}/rename`;
}, xi = { id: "ParamsPatchScenarioGroupRename", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, zi = { id: "BodyPatchScenarioGroupRename", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 } } }, ki = ({ params: e, body: t }) => {
  const s = H(xi, e);
  if (!s) return s;
  const n = B(zi, t);
  return !!n || n;
}, Uo = (e) => O({ ...e, method: N.PATCH, getEndpoint: Ji, preflightValidation: ki }), Wi = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/scenarios/${e.scenarioId}/push_to_review`;
}, Qi = { id: "ParamsPostReview", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, Bi = { id: "BodyPostReview", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 } } }, Xi = ({ params: e, body: t }) => {
  const s = H(Qi, e);
  if (!s) return s;
  const n = B(Bi, t);
  return !!n || n;
}, No = (e) => O({ ...e, method: N.POST, getEndpoint: Wi, preflightValidation: Xi }), es = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenario-groups`;
}, ts = { id: "ParamsPostScenarioGroups", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, rs = { id: "BodyPostScenarioGroups", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 }, orderIndex: { type: "number", required: !0 } } }, as = ({ params: e, body: t }) => {
  const s = H(ts, e);
  if (!s) return s;
  const n = B(rs, t);
  return !!n || n;
}, Oo = (e) => O({ ...e, method: N.POST, getEndpoint: es, preflightValidation: as }), is = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/clusters/${e.clusterId}/planograms`;
}, ss = { id: "ParamsGetClusterPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 }, clusterId: { type: "integer", required: !0 } }, required: !0 }, ns = ({ params: e }) => H(ss, e), Lo = (e, t) => O({ ...t, method: N.GET, getEndpoint: is, preflightValidation: ns }, e), os = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/curate/scenarios/${e.scenarioId}/store-results/${e.storeId}`;
}, ps = { id: "ParamsGetCurateStoreProducts", type: "object", properties: { scenarioId: { type: "integer", required: !0 }, storeId: { type: "integer", required: !0 } }, required: !0 }, Es = { id: "QueryGetCurateProductSummaries", type: "object", properties: { ordering: { type: "string", required: !0 } }, required: !0 }, ds = ({ params: e, query: t }) => {
  const s = H(ps, e);
  if (!s) return s;
  const n = ne(Es, t);
  return !!n || n;
}, Co = (e, t) => O({ ...t, method: N.GET, getEndpoint: os, preflightValidation: ds }, e), _s = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios/${e.scenarioId}/store-list`;
}, us = { id: "ParamsGetCurateStores", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, hs = { id: "QueryGetCurateProductSummaries", type: "object", properties: { offset: { type: "integer", required: !0 }, limit: { type: "integer", required: !0 }, ordering: { type: "string", required: !0 }, direction: { type: "string", required: !0 }, agg_vals: { type: "string", required: !0 }, aggregation: { type: "string", required: !0 } }, required: !0 }, cs = ({ params: e, query: t }) => {
  const s = H(us, e);
  if (!s) return s;
  const n = ne(hs, t);
  return !!n || n;
}, Do = (e, t) => O({ ...t, method: N.GET, getEndpoint: _s, preflightValidation: cs }, e), As = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/stores/kpi_summary`;
}, Is = { id: "ParamsGetStoreKpiSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, gs = ({ params: e }) => H(Is, e), Ho = (e, t) => O({ ...t, method: N.GET, getEndpoint: As, preflightValidation: gs }, e), Ss = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/stores/${e.storeId}/planograms`;
}, Ts = { id: "ParamsGetStoresPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 }, storeId: { type: "integer", required: !0 } }, required: !0 }, vs = ({ params: e }) => H(Ts, e), Vo = (e, t) => O({ ...t, method: N.GET, getEndpoint: Ss, preflightValidation: vs }, e), Ps = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/stores/summaries`;
}, ls = { id: "ParamGetStoresSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, ys = { id: "QueryGetStoreSummaries", type: "object", properties: { group_by: { type: "string", required: !0, minLength: 1 } }, required: !0 }, ms = ({ params: e, query: t }) => {
  const s = H(ls, e);
  if (!s) return s;
  const n = ne(ys, t);
  return !!n || n;
}, bo = (e, t) => O({ ...t, method: N.GET, getEndpoint: Ps, preflightValidation: ms }, e), Rs = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/ie/documents/${e.documentId}/stores/planograms-export`;
}, fs = { id: "ParamsPostExportPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Us = ({ params: e }) => H(fs, e), Go = () => {
  const [e, t] = G(!1), [s, n] = G(), [A, v] = G(), [S, y, L, f] = At(), p = b((u) => {
    if (typeof u == "string") n(u), t(!1);
    else if (u instanceof Object && Object.hasOwn(u, "taskId")) L({ params: { taskId: u.taskId } });
    else {
      const P = { isError: !0, data: { type: "process-error", error_code: "UnknownResponse", status_code: -1, message: "unknown response type from posting assortment request", response: u } };
      v(P), console.warn(P);
    }
    return u;
  }, [L]), E = b((u) => {
    v(u), t(!1);
  }, []), [T, I, a] = O({ method: N.POST, getEndpoint: Rs, preflightValidation: Us, onSuccess: p, onFailure: E }), _ = b((u) => {
    t(!0), a({ ...u, body: void 0 });
  }, [a]);
  return X(() => {
    S || (f ? console.warn(f) : (n(y), t(!1)));
  }, [S, y, f]), ae(() => [e, s, _, A], [A, s, e, _]);
};
var Ns = ((e) => (e.UNIT = "UNIT", e.TRAY = "TRAY", e.CASE = "CASE", e.DISPLAY = "DISPLAY", e.ALTERNATE = "ALTERNATE", e))(Ns || {}), Os = ((e) => (e.FIXTURE = "Fixture", e.SHELF = "Shelf", e.FLOATING = "FloatingShelf", e))(Os || {});
const Ls = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/strategies/${e.strategy_id}/aggregation`;
}, Cs = { id: "ParamsGetStrategyAggregation", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, Ds = { id: "QueryGetStrategyAggregation", type: "object", properties: { aggregation: { type: "string", required: !0, minLength: 1 } }, required: !0 }, Hs = ({ params: e, query: t }) => {
  const s = H(Cs, e);
  if (!s) return s;
  const n = ne(Ds, t);
  return !!n || n;
}, qo = (e, t) => O({ ...t, method: N.GET, getEndpoint: Ls, preflightValidation: Hs }, e);
var Vs = ((e) => (e.CALCULATE = "calculate", e.RESET = "reset", e.SAVE = "save", e))(Vs || {}), ye = ((e) => (e.NOT_READY = "not_ready", e.READY = "ready", e.PENDING = "pending", e.IN_PROGRESS = "in_progress", e.READ_ONLY = "read_only", e))(ye || {}), de = ((e) => (e.NAME_ASC = "+name", e.NAME_DES = "-name", e.CREATED_ASC = "+created_on", e.CREATED_DES = "-created_on", e.UPDATED_ASC = "+updated_on", e.UPDATED_DES = "-updated_on", e.ARCHIVED_ASC = "+archived_on", e.ARCHIVED_DES = "-archived_on", e))(de || {}), bs = ((e) => (e.CATEGORY = "category", e.SUB_CATEGORY = "sub_category", e.BRAND = "brand", e.SUB_BRAND = "sub_brand", e.PACK_GROUP = "pack_group", e))(bs || {});
const Gs = ({ params: e, query: t }) => {
  const s = { ENV: "staging", HIVEMIND_ENV: "stg.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://stg.hivery.ai/api/v1/curate", CURATE_API_V2: "https://stg.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://stg.hivery.ai/api/v1/ie", PREDICTION_API: "https://stg.hivery.ai/api/v1/prediction", SSDI_API: "https://stg.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://stg.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://stg.hivery.ai/api/v1/strategies", AGENT_API: "https://stg.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "gSrXJ9P8FvZdua2q1gYqswVOJqQqRpdd", AUTH0_DOMAIN: "auth.stg.hivery.ai", AUTH0_AUDIENCE: "propel-api-staging", PUSHER_APP_KEY: "ed81ada4152f5becc720", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "ed81ada4152f5becc720", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://stg.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.stg.hivery.ai" };
  return typeof e == "boolean" ? `${s.STRATEGY_API}` : e || t ? t ? `${s.STRATEGY_API}` : e ? `${s.STRATEGY_API}/${e.strategy_id}` : void 0 : void 0;
}, qs = { id: "ParamsGetStrategies", type: "object", properties: { strategy_id: { type: "string", required: !1 } }, required: !1 }, Fs = { id: "QueryGetStrategies", type: "object", properties: { project_id: { type: "integer", required: !1 }, dataset_id: { type: "string", required: !1 }, model_id: { type: "string", required: !1 }, assortment_id: { type: "string", required: !1 }, kpi_id: { type: "string", required: !1 }, planogram_id: { type: "string", required: !1 }, state_status: { type: "string", required: !1, enum: [ye.NOT_READY, ye.READY, ye.PENDING, ye.IN_PROGRESS, ye.READ_ONLY] }, order_by: { type: "string", required: !1, enum: [de.NAME_ASC, de.NAME_DES, de.CREATED_ASC, de.CREATED_DES, de.UPDATED_ASC, de.UPDATED_DES, de.ARCHIVED_ASC, de.ARCHIVED_DES] }, limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 } }, required: !1 }, Ms = ({ params: e, query: t }) => {
  let s = !0;
  if (typeof e == "boolean") return !0;
  if (s = H(qs, e), !s) return s;
  const n = ne(Fs, t);
  return !!n || n;
}, Fo = (e, t) => {
  let s;
  return typeof e == "boolean" ? s = { params: e } : s = e, O({ ...t, method: N.GET, getEndpoint: Gs, preflightValidation: Ms }, s);
}, Ys = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/strategies/${e.strategy_id}/generate-data`;
}, ws = { id: "ParamsPostStrategyGenerateData", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, js = { id: "BodyPostStrategyGenerateData", type: "object", properties: { stores: { type: "integer", required: !0 }, categories: { type: "integer", required: !0 }, sub_categories: { type: "integer", required: !0 }, brands: { type: "integer", required: !0 }, sub_brands: { type: "integer", required: !0 }, pack_groups: { type: "integer", required: !0 }, products: { type: "integer", required: !0 }, dist_min: { type: "integer", required: !0 }, dist_max: { type: "integer", required: !0 } }, required: !0 }, Ks = ({ params: e, body: t }) => {
  const s = H(ws, e);
  if (!s) return s;
  const n = B(js, t);
  return !!n || n;
}, Mo = (e) => O({ ...e, method: N.POST, getEndpoint: Ys, preflightValidation: Ks }), $s = ({ params: e }) => {
  if (e)
    return `https://stg.hivery.ai/api/v1/strategies/${e.strategy_id}/ingest-data`;
}, Zs = { id: "ParamsPostStrategyIngestData", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, Ae = { type: "array", required: !0, minItems: 1, items: { type: "string" }, additionalItems: !1 }, Js = { id: "BodyPostStrategyIngestData", type: "object", properties: { descriptors: { type: "object", properties: { brands: Ae, subBrands: Ae, categories: Ae, subCategories: Ae, subSubCategories: Ae, manufacturers: Ae, packGroups: Ae, productGroups: Ae } }, products: { type: "array", required: !0, minItems: 1, items: { type: "object", properties: { id: { type: "integer", required: !0 }, upc: { type: "string", required: !0 }, name: { type: "string", required: !0 }, brand: { type: "string", required: !0 }, subBrand: { type: "string", required: !0 }, category: { type: "string", required: !0 }, subCategory: { type: "string", required: !0 }, subSubCategory: { type: "string", required: !0 }, packGroup: { type: "string", required: !0 }, productGroup: { type: "string", required: !0 }, storeIds: { type: "array", required: !0, items: { type: "integer" }, additionalItems: !1 }, podCount: { type: "integer", required: !0 }, weeklyMovement: { type: "number", required: !0 }, weeklyRevenue: { type: "number", required: !0 } } }, additionalItems: !1 } }, required: !0 }, xs = ({ params: e, body: t }) => {
  const s = H(Zs, e);
  if (!s) return s;
  const n = B(Js, t);
  return !!n || n;
}, Yo = (e) => O({ ...e, method: N.POST, getEndpoint: $s, preflightValidation: xs }), zs = () => "https://stg.hivery.ai/api/v1/strategies/", ks = { id: "BodyPostStrategies", type: "object", properties: { project_id: { type: "integer", required: !0 }, scenario_id: { type: "integer", required: !0 }, name: { type: "string", required: !0, minLength: 1 } }, required: !0 }, Ws = ({ body: e }) => B(ks, e), wo = (e) => O({ ...e, method: N.POST, getEndpoint: zs, preflightValidation: Ws }), Qs = () => "https://stg.hivery.ai/api/v1/curate/users/customer-groups", jo = (e = !0, t) => O({ ...t, method: N.GET, getEndpoint: Qs }, { params: e }), Bs = () => "https://stg.hivery.ai/api/v1/curate/users/me", Ko = (e = !0, t) => O({ ...t, method: N.GET, getEndpoint: Bs, tenantRequired: !1 }, { params: e }), Xs = () => "https://stg.hivery.ai/api/v1/curate/users/customer-groups", en = { id: "BodyPatchUserCustomerGroup", type: "object", properties: { id: { type: "integer", required: !0 } } }, tn = ({ body: e }) => B(en, e), $o = (e) => O({ ...e, method: N.PATCH, getEndpoint: Xs, preflightValidation: tn }), rn = () => "https://stg.hivery.ai/api/v1/curate/passwordless/send-email", an = { id: "BodyPostLoginPasswordless", type: "object", properties: { email: { type: "string", required: !0, minLength: 1 } } }, sn = ({ body: e }) => B(an, e), Zo = (e) => O({ ...e, method: N.POST, getEndpoint: rn, preflightValidation: sn, authRequired: !1 }), nn = ({ base_params: e, sendForm: t, maxChunks: s = 10, chunkSize: n = 2097152 }) => {
  const [A, v] = G(!1), [S, y] = G(), L = (f, p, E) => {
    const T = new FormData();
    return f.forEach((I, a) => {
      T.append(`${E + a}-${p}`, I);
    }), T;
  };
  return [A, b((f, p) => {
    const E = f.type, T = f.name, I = f.stream().getReader({ mode: "byob" });
    return y(Math.ceil(f.size / n / s)), new Promise((a, _) => {
      let u = new Uint8Array(n), P = new Uint8Array(n), m = 0, D = 0, i = [], r = 0, d = {};
      e || p ? (e && (d = { ...e }), p && (d = { ...p }), v(!0), I.read(u).then(async function h({ done: o, value: l }) {
        if (o) {
          const c = new Uint8Array(m);
          c.set(P.slice(0, m));
          const g = new Blob([c], { type: E });
          i.push(g), D++;
          const U = L(i, T, r * s), C = { params: { ...d, part_number: r }, body: U };
          return r++, console.debug(`readStream() complete. Total Form Count: ${r}`), await t(C), a({ readComplete: !0, partCount: D, formCount: r }), void v(!1);
        }
        if (u = new Uint8Array(n), m + l.byteLength > n) {
          const c = n - m, g = new Uint8Array(n);
          g.set(P), g.set(l.slice(0, c), c);
          const U = new Blob([g], { type: E });
          i.push(U), D++, P = new Uint8Array(n), P.set(l.slice(c + 1, l.byteLength)), m = l.byteLength - (c + 1);
        } else if (P.set(l, m), m += l.byteLength, m === n) {
          const c = new Blob([P], { type: E });
          i.push(c), D++, P = new Uint8Array(n), m = 0;
        }
        if (D === s) {
          const c = L(i, T, r * s), g = { params: { ...d, part_number: r }, body: c };
          r++, await t(g), D = 0, i = [];
        }
        return I.read(u).then(h);
      })) : _({ readComplete: !1, partCount: D, formCount: r, isError: !0, error: "Unable to build file forms: missing request params" });
    });
  }, [n, s, e, t]), S];
}, je = 1048576, Et = 1024 * je, gt = _t(null), Jo = () => {
  const e = ut(gt);
  if (!e) throw new Error("useFileUploadContextSSDI must be used within a FileUploadSSDIProvider");
  return e;
}, on = Tt(({ children: e, kind: t, ...s }, n) => {
  const [A, v] = G(null), [S, y] = G(null), [L, f] = G(!1), [p, E] = G(!1), [T, I] = G(!1), [a, _] = G(!1), [u, P] = G(!1), [m, D] = G([]), [i, r] = G(), [d, h] = G(0), o = re(0), [l, c] = G(), g = ae(() => {
    if (!A) return;
    const V = A.size;
    return V < je ? `${(V / 1024).toFixed(2)}KB` : V < Et ? `${(V / je).toFixed(2)}MB` : `${(V / Et).toFixed(2)}GB`;
  }, [A]), [U, C, $, Y] = Qr(), [J, ue, w, W] = ra(), ie = b(() => {
    h((V) => V + 1);
  }, []), he = b(() => {
    if (!(J || u || W)) if (i) if (C) if (S) {
      if (d === i.formCount) {
        const V = (performance.now() - o.current) / 1e3, q = mt(m, "part").map((z) => z.id);
        c(V), _(!0), I(!1), w({ params: { id: C.id }, body: { filePartIds: q, kind: C.kind, ext: S } });
      }
    } else console.debug("unable to process uploaded file: file ext not known");
    else console.debug("unable to process uploaded file empty queue: file meta data missing");
    else console.debug("unable to process uploaded file empty queue: file stats missing");
  }, [S, d, i, m, W, w, u, J, C]), Te = b((V) => {
    D((q) => V.isError ? q : [...q, { id: V.data.id, part: V.data.partNumber }]);
  }, []), [ge, Oe] = na({ headers: { "X-File-Upload-Kind": t }, onFinish: ie, onEmptyQueue: he, onResponse: Te }), [me, Le, Re] = nn({ sendForm: Oe }), Ce = b((V) => {
    P(!1), _(!1), I(!1), E(!1), f(!1), r(void 0), h(0), c(void 0), o.current = 0;
    const q = yt(V.type);
    q && (y(q), v(V));
  }, []), De = b(() => {
    !L && A && (P(!1), _(!1), I(!1), E(!1), r(void 0), h(0), c(void 0), o.current = 0, f(!0), $({ body: { kind: t, name: A.name } }));
  }, [A, L, t, $]), R = ae(() => ({ isFileInProgress: L, isFilePrepared: p, isFilePreparing: U, isFileUploaded: a, isFileUploading: T, isFileFinialized: u, isFileFinializing: J, fileRequestCount: d, fileRequestExpectedCount: Re, fileStats: i, fileSizeLabel: g, fileUploadDuration: l, setFile: Ce, sendFile: De, fileUploadError: Y || W }), [d, Re, g, i, l, W, u, J, L, p, U, a, T, Y, De, Ce]);
  return X(() => {
    Y && f(!1);
  }, [Y]), X(() => {
    !A || !C || me || ge || T || a || (o.current = performance.now(), Le(A, { id: C.id }).then((V) => {
      r(V);
    }), c(void 0), I(!0), E(!0));
  }, [Le, A, me, J, a, T, ge, C]), X(() => {
    W && f(!1);
  }, [W]), X(() => {
    ue && (P(!0), f(!1));
  }, [ue]), Me.jsx(gt.Provider, { value: R, children: Me.jsx("div", { ref: n, ...s, children: e }) });
});
on.displayName = "FileUploadSSDIProvider";
export {
  rr as AGENT_ASSISTANT_TYPES,
  yn as AGENT_MESSAGE_CONTENT_CHART_DATA_FIELD_KINDS,
  mn as AGENT_MESSAGE_CONTENT_CHART_GEOMETRY_KINDS,
  Rn as AGENT_MESSAGE_CONTENT_CHART_IMAGE_MIME_KINDS,
  ln as AGENT_MESSAGE_CONTENT_KINDS,
  ir as AGENT_MESSAGE_ROLES,
  Pn as AGENT_MESSAGE_STATUSES,
  fn as AGENT_RUN_STATUSES,
  ar as AGENT_THREAD_SCOPE_LEVELS,
  pt as ALGORITHM_TYPES,
  Dr as AssortedStatus,
  no as CONSTRAINT_KINDS_ASSORTMENT_CONTROLS,
  oo as CONSTRAINT_KINDS_ASSORTMENT_OVERRIDES,
  Eo as CONSTRAINT_KINDS_SPACE_APPEARANCE,
  po as CONSTRAINT_KINDS_SPACE_LIMIT,
  _o as CONSTRAINT_KINDS_SPACE_MERCHANDIZING,
  Mr as DocumentState,
  ft as DomExceptionName,
  _e as EditRequestsCommandTypes,
  we as EditRequestsStatuses,
  eo as FILE_EXPORT_STATUS,
  Ha as FILE_EXPORT_TYPE,
  N as FetchMethod,
  gt as FileUploadContextSSDI,
  on as FileUploadSSDIProvider,
  Os as FixtureType,
  ot as GET_PROJECT_ORDER_BY,
  Ns as MerchandiseStyle,
  Ue as PlanogramFileFormat,
  Da as ProjectImportStatuses,
  gi as SCENARIO_NATIONAL_RESULTS_GROUPINGS,
  be as SCENARIO_NATIONAL_RESULTS_ORDER,
  ci as ScenarioOptimizationCodes,
  hi as ScenarioOptimizationStatuses,
  Ii as ScenarioReviewMetaStatuses,
  Ai as ScenarioType,
  $a as SchemaBodyPatchProject,
  za as SchemaBodyPatchProjectSettings,
  Ci as SchemaBodyPatchReview,
  Fi as SchemaBodyPatchScenarioAssignGroup,
  zi as SchemaBodyPatchScenarioGroupRename,
  en as SchemaBodyPatchUserCustomerGroup,
  nr as SchemaBodyPostAgentAssistant,
  dr as SchemaBodyPostAgentMessage,
  cr as SchemaBodyPostAgentRun,
  gr as SchemaBodyPostAgentThread,
  kr as SchemaBodyPostFilesUpload,
  ea as SchemaBodyPostFilesUploadComplete,
  an as SchemaBodyPostLoginPasswordless,
  Qa as SchemaBodyPostProject,
  Bi as SchemaBodyPostReview,
  rs as SchemaBodyPostScenarioGroups,
  ks as SchemaBodyPostStrategies,
  js as SchemaBodyPostStrategyGenerateData,
  Js as SchemaBodyPostStrategyIngestData,
  Ua as SchemaParamsDeleteProjects,
  ai as SchemaParamsDeleteScenario,
  wt as SchemaParamsGetAgentAssistants,
  $t as SchemaParamsGetAgentMessage,
  xt as SchemaParamsGetAgentRun,
  Wt as SchemaParamsGetAgentThreads,
  vr as SchemaParamsGetAssortment,
  ss as SchemaParamsGetClusterPlanograms,
  Ea as SchemaParamsGetCurateProduct,
  ua as SchemaParamsGetCurateProductSummaries,
  ps as SchemaParamsGetCurateStoreProducts,
  us as SchemaParamsGetCurateStores,
  Vr as SchemaParamsGetDocuments,
  qr as SchemaParamsGetDocumentsSummaries,
  wr as SchemaParamsGetEditRequestsMostRecent,
  yr as SchemaParamsGetPODS,
  Ia as SchemaParamsGetProductDemandTransfer,
  va as SchemaParamsGetProductSummaries,
  ma as SchemaParamsGetProducts,
  La as SchemaParamsGetProjectDataDetails,
  ba as SchemaParamsGetProjectExportUrl,
  Ma as SchemaParamsGetProjects,
  ni as SchemaParamsGetReviews,
  _i as SchemaParamsGetScenarioGroups,
  mi as SchemaParamsGetScenarios,
  Ui as SchemaParamsGetScenariosBaseCore,
  Ti as SchemaParamsGetScenariosNationalResults,
  Is as SchemaParamsGetStoreKpiSummaries,
  Ts as SchemaParamsGetStoresPlanograms,
  ls as SchemaParamsGetStoresSummaries,
  qs as SchemaParamsGetStrategies,
  Cs as SchemaParamsGetStrategyAggregation,
  fr as SchemaParamsGetTasksStatus,
  Xt as SchemaParamsListAgentMessages,
  Ka as SchemaParamsPatchProject,
  xa as SchemaParamsPatchProjectSettings,
  Li as SchemaParamsPatchReview,
  Vi as SchemaParamsPatchScenario,
  qi as SchemaParamsPatchScenarioAssignGroup,
  wi as SchemaParamsPatchScenarioGroupArchive,
  $i as SchemaParamsPatchScenarioGroupArchiveUndo,
  xi as SchemaParamsPatchScenarioGroupRename,
  Er as SchemaParamsPostAgentMessage,
  hr as SchemaParamsPostAgentRun,
  Zr as SchemaParamsPostEditRequestsCreate,
  Lr as SchemaParamsPostExportAssortment,
  fs as SchemaParamsPostExportPlanograms,
  Xr as SchemaParamsPostFilesUploadComplete,
  ia as SchemaParamsPostFilesUploadPart,
  Qi as SchemaParamsPostReview,
  ts as SchemaParamsPostScenarioGroups,
  ws as SchemaParamsPostStrategyGenerateData,
  Zs as SchemaParamsPostStrategyIngestData,
  ei as SchemaQueryGetConstraintTypess,
  ha as SchemaQueryGetCurateProductSummaries,
  Es as SchemaQueryGetCurateStoreProducts,
  hs as SchemaQueryGetCurateStores,
  ga as SchemaQueryGetProductDemandTransfer,
  Pa as SchemaQueryGetProductSummaries,
  Ya as SchemaQueryGetProjects,
  vi as SchemaQueryGetScenariosNationalResults,
  ys as SchemaQueryGetStoreSummaries,
  Fs as SchemaQueryGetStrategies,
  Ds as SchemaQueryGetStrategyAggregation,
  er as SchemaQueryListAgentMessages,
  de as StrategiesOrderBy,
  bs as StrategyAggregationType,
  ye as StrategyStatusType,
  Vs as StrategyTaskType,
  le as TaskStatuses,
  It as UPLOAD_FILE_KINDS,
  Zn as UPLOAD_FILE_STATUSES,
  ct as UserStateContext,
  Vt as UserStateContextInit,
  ht as UserStateInit,
  hn as UserStateProvider,
  qe as cleanQueryParams,
  fa as endpointDeleteProjects,
  ri as endpointDeleteScenario,
  Yt as endpointGetAgentAssistants,
  Kt as endpointGetAgentMessage,
  Jt as endpointGetAgentRun,
  kt as endpointGetAgentThreads,
  Tr as endpointGetAssortment,
  is as endpointGetClusterPlanograms,
  Xa as endpointGetConstraintTypess,
  pa as endpointGetCurateProduct,
  _a as endpointGetCurateProductSummaries,
  os as endpointGetCurateStoreProducts,
  _s as endpointGetCurateStores,
  Qs as endpointGetCustomerGroups,
  Hr as endpointGetDocuments,
  Gr as endpointGetDocumentsSummaries,
  Yr as endpointGetEditRequestsMostRecent,
  Bs as endpointGetMe,
  lr as endpointGetPODs,
  oa as endpointGetPreferences,
  Aa as endpointGetProductDemandTransfer,
  Ta as endpointGetProductSummaries,
  ya as endpointGetProducts,
  Oa as endpointGetProjectDataDetails,
  Va as endpointGetProjectExportUrl,
  Fa as endpointGetProjects,
  qa as endpointGetProjectsFileUploadConfig,
  si as endpointGetReviews,
  pi as endpointGetScenarioAggregationOptions,
  Ei as endpointGetScenarioFileUploadConfig,
  di as endpointGetScenarioGroups,
  yi as endpointGetScenarios,
  fi as endpointGetScenariosBaseCore,
  Si as endpointGetScenariosNationalResults,
  As as endpointGetStoreKpiSummaries,
  Ss as endpointGetStoresPlanograms,
  Gs as endpointGetStrategies,
  Ls as endpointGetStrategyAggregation,
  Rr as endpointGetTasksStatus,
  xr as endpointGetTestAuth,
  Bt as endpointListAgentMessages,
  ja as endpointPatchProject,
  Ja as endpointPatchProjectSettings,
  Oi as endpointPatchReview,
  Hi as endpointPatchScenario,
  Gi as endpointPatchScenarioAssignGroup,
  Yi as endpointPatchScenarioGroupArchive,
  Ki as endpointPatchScenarioGroupArchiveUndo,
  Ji as endpointPatchScenarioGroupRename,
  Xs as endpointPatchUserCustomerGroup,
  sr as endpointPostAgentAssistant,
  pr as endpointPostAgentMessage,
  ur as endpointPostAgentRun,
  Ir as endpointPostAgentThread,
  $r as endpointPostEditRequestsCreate,
  Or as endpointPostExportAssortment,
  Rs as endpointPostExportPlanograms,
  zr as endpointPostFilesUpload,
  Br as endpointPostFilesUploadComplete,
  aa as endpointPostFilesUploadPart,
  rn as endpointPostLoginPasswordless,
  Wa as endpointPostProject,
  Wi as endpointPostReview,
  es as endpointPostScenarioGroups,
  zs as endpointPostStrategies,
  Ys as endpointPostStrategyGenerateData,
  $s as endpointPostStrategyIngestData,
  li as formatQueryGetScenariosNationalResults,
  qt as getChunkSize,
  Ps as getEndpointGetStoresSummaries,
  _n as getEnvConfig,
  yt as getFileExt,
  Ut as handleDomException,
  Mt as handleHTTPStatus,
  un as indexByProp,
  Na as preflightValidationDeleteProjects,
  ii as preflightValidationDeleteScenario,
  jt as preflightValidationGetAgentAssistants,
  Zt as preflightValidationGetAgentMessage,
  zt as preflightValidationGetAgentRun,
  Qt as preflightValidationGetAgentThreads,
  Pr as preflightValidationGetAssortment,
  ns as preflightValidationGetClusterPlanograms,
  ti as preflightValidationGetConstraintTypess,
  da as preflightValidationGetCurateProduct,
  ca as preflightValidationGetCurateProductSummaries,
  ds as preflightValidationGetCurateStoreProducts,
  cs as preflightValidationGetCurateStores,
  br as preflightValidationGetDocuments,
  Fr as preflightValidationGetDocumentsSummaries,
  jr as preflightValidationGetEditRequestsMostRecent,
  mr as preflightValidationGetPODs,
  Sa as preflightValidationGetProductDemandTransfer,
  la as preflightValidationGetProductSummaries,
  Ra as preflightValidationGetProducts,
  Ca as preflightValidationGetProjectDataDetails,
  Ga as preflightValidationGetProjectExportUrl,
  wa as preflightValidationGetProjects,
  oi as preflightValidationGetReviews,
  ui as preflightValidationGetScenarioGroups,
  Ri as preflightValidationGetScenarios,
  Ni as preflightValidationGetScenariosBaseCore,
  Pi as preflightValidationGetScenariosNationalResults,
  gs as preflightValidationGetStoreKpiSummaries,
  ms as preflightValidationGetStoreSummaries,
  vs as preflightValidationGetStoresPlanograms,
  Ms as preflightValidationGetStrategies,
  Hs as preflightValidationGetStrategyAggregation,
  Ur as preflightValidationGetTasksStatus,
  tr as preflightValidationListAgentMessages,
  Za as preflightValidationPatchProject,
  ka as preflightValidationPatchProjectSettings,
  Di as preflightValidationPatchReview,
  bi as preflightValidationPatchScenario,
  Mi as preflightValidationPatchScenarioAssignGroup,
  ji as preflightValidationPatchScenarioGroupArchive,
  Zi as preflightValidationPatchScenarioGroupArchiveUndo,
  ki as preflightValidationPatchScenarioGroupRename,
  tn as preflightValidationPatchUserCustomerGroup,
  or as preflightValidationPostAgentAssistant,
  _r as preflightValidationPostAgentMessage,
  Ar as preflightValidationPostAgentRun,
  Sr as preflightValidationPostAgentThread,
  Jr as preflightValidationPostEditRequestsCreate,
  Cr as preflightValidationPostExportAssortment,
  Us as preflightValidationPostExportPlanograms,
  Wr as preflightValidationPostFilesUpload,
  ta as preflightValidationPostFilesUploadComplete,
  sa as preflightValidationPostFilesUploadPart,
  sn as preflightValidationPostLoginPasswordless,
  Ba as preflightValidationPostProject,
  Xi as preflightValidationPostReview,
  as as preflightValidationPostScenarioGroups,
  Ws as preflightValidationPostStrategies,
  Ks as preflightValidationPostStrategyGenerateData,
  xs as preflightValidationPostStrategyIngestData,
  nt as setUser,
  rt as setUserFeatures,
  at as setUserTenant,
  it as setUserTenantSlug,
  st as setUserToken,
  mt as sortByProp,
  Bn as useDeleteProject,
  co as useDeleteScenario,
  Ne as useFetch,
  cn as useFetchBatch,
  Gt as useFetchConcurrentAsyc,
  An as useFetchDrain,
  O as useFetchRequest,
  nn as useFileChunkFormBuilder,
  Jo as useFileUploadContextSSDI,
  In as useGetAgentAssistants,
  gn as useGetAgentMessage,
  Sn as useGetAgentRun,
  Tn as useGetAgentThreads,
  Cn as useGetAssortments,
  Ft as useGetChunk,
  Lo as useGetClusterPlanograms,
  ho as useGetConstraintTypes,
  xn as useGetCurateProduct,
  zn as useGetCurateProductSummaries,
  Co as useGetCurateStoreProducts,
  Do as useGetCurateStores,
  jo as useGetCustomerGroups,
  Vn as useGetDocuments,
  bn as useGetDocumentsSummaries,
  Kr as useGetEditRequestsMostRecent,
  Ko as useGetMe,
  Dn as useGetPODs,
  Jn as useGetPreferences,
  kn as useGetProductDemandTransfer,
  Wn as useGetProductSummaries,
  Qn as useGetProducts,
  Xn as useGetProjectDataDetails,
  to as useGetProjectExportUrl,
  ao as useGetProjects,
  ro as useGetProjectsFileUploadConfig,
  Ao as useGetReviews,
  Io as useGetScenarioAggregationOptions,
  go as useGetScenarioFileUploadConfig,
  So as useGetScenarioGroups,
  vo as useGetScenarios,
  Po as useGetScenariosBaseCore,
  To as useGetScenariosNationalResults,
  Ho as useGetStoreKpiSummaries,
  Vo as useGetStoresPlanograms,
  bo as useGetStoresSummaries,
  Fo as useGetStrategies,
  qo as useGetStrategyAggregation,
  Nr as useGetTasksStatus,
  $n as useGetTestAuth,
  vn as useListAgentMessages,
  io as usePatchProject,
  so as usePatchProjectSettings,
  lo as usePatchReview,
  yo as usePatchScenario,
  mo as usePatchScenarioAssignGroup,
  Ro as usePatchScenarioGroupArchive,
  fo as usePatchScenarioGroupArchiveUndo,
  Uo as usePatchScenarioGroupRename,
  $o as usePatchUserCustomerGroup,
  At as usePollTaskStatus,
  Un as usePostAgentAssistant,
  Nn as usePostAgentMessage,
  On as usePostAgentRun,
  Ln as usePostAgentThread,
  Gn as usePostEditRequestDropPosition,
  qn as usePostEditRequestDropProduct,
  Fn as usePostEditRequestInsertPosition,
  Mn as usePostEditRequestInsertProduct,
  Yn as usePostEditRequestMovePosition,
  wn as usePostEditRequestSetFacings,
  jn as usePostEditRequestSwapPosition,
  Kn as usePostEditRequestSwapProduct,
  Ie as usePostEditRequestsCreate,
  Hn as usePostExportAssortment,
  Go as usePostExportPlanograms,
  Qr as usePostFilesUpload,
  ra as usePostFilesUploadComplete,
  na as usePostFilesUploadPart,
  Zo as usePostLoginPasswordless,
  uo as usePostProject,
  No as usePostReview,
  Oo as usePostScenarioGroups,
  wo as usePostStrategies,
  Mo as usePostStrategyGenerateData,
  Yo as usePostStrategyIngestData,
  Dt as useSetUser,
  Nt as useSetUserFeatures,
  Ot as useSetUserTenant,
  Lt as useSetUserTenantSlug,
  Ct as useSetUserToken,
  bt as useUserState,
  Ht as userReducer,
  B as validateBody,
  H as validateParams,
  ne as validateQuery,
  Ge as valueByProp
};
//# sourceMappingURL=api.js.map
